export const en = {
  appName: 'V·IANet Governance',
  brandName: 'VALOR·IA Governance',
  poweredBy: 'powered by',

  sidebar: {
    explorer: 'Document Explorer',
    processMap: 'PROCESS MAP',
    collapseAll: '▶ All',
    expandAll: '▼ All',
    strategic: 'Strategic Processes',
    operational: 'Operational Processes',
    support: 'Support Processes',
    structure: 'Structure',
    process: 'Process',
    information: 'Information',
    compliance: 'Compliance',
    tech: 'Technology',
    reputation: 'Reputation',
    settings: 'Settings',
    ingenierias: 'Engineering',
    actionCenter: 'Action Center',
    allOrgs: 'All organizations',
    cambiarTenant: 'Switch organization',
    salir: 'Sign out',
    userMenu: {
      miCuenta: 'My account',
      backoffice: 'Backoffice',
      cambiarOrganizacion: 'Switch organization',
      cerrarSesion: 'Sign out',
      superadminBadge: 'Platform Admin',
      rolBadge: 'Role',
    },
    pageTitle: {
      processMap: 'Corporate Governance',
      structure: 'Organizational Structure',
      process: 'Process Architecture',
      information: 'Business Information Management',
      compliance: 'Regulatory Compliance',
      tech: 'Information Technologies',
      reputation: 'Reputational Communication Management',
      settings: 'Settings',
    },
  },

  explorer: {
    title: 'Document Explorer',
    subtitle: (total: number) => `${total} documents in the management system`,
    totalDocs: 'Total documents',
    published: 'Published',
    draft: 'Draft',
    inReview: 'In review',
    allTypes: 'All types',
    allStates: 'All states',
    allProcesses: 'All processes',
    search: 'Search documents...',
    clearFilters: '✕ Clear',
    showing: (from: number, to: number, total: number) =>
      `Showing ${from}–${to} of ${total} documents`,
    noResults: 'No documents found',
    newDocument: '+ New document',
    previous: '← Previous',
    next: 'Next →',
  },

  table: {
    code: 'Code',
    title: 'Title',
    type: 'Type',
    process: 'Process',
    status: 'Status',
    direction: 'Dir.',
    edition: 'Ed.',
    date: 'Date',
  },

  docType: {
    PR: 'Procedure',
    NC: 'Corporate Standard',
    IT: 'Work Instruction',
    MN: 'Manual',
    PA: 'Action Plan',
    RE: 'Report',
    FC: 'Process Sheet',
    FL: 'Flowchart',
    HE: 'Tool',
    MO: 'Template',
    PT: 'Protocol',
    FR: 'Functional Role Sheet',
    FP: 'Position Sheet',
    FG: 'Governance Role Sheet',
  },

  status: {
    BORRADOR: 'Draft',
    EN_REVISION: 'In Review',
    APROBADO: 'Approved',
    PUBLICADO: 'Published',
    ARCHIVADO: 'Archived',
  },

  versionStatus: {
    BORRADOR: 'Draft',
    EN_REVISION: 'In Review',
    ENVIADO: 'Submitted',
    APROBADO: 'Approved',
    PUBLICADO: 'In Force',
    ARCHIVADO: 'Archived',
    RECHAZADO: 'Rejected',
  },

  docTypes: {
    PR: 'Procedure',
    NC: 'Corporate Standard',
    IT: 'Work Instruction',
    MN: 'Manual',
    PA: 'Action Plan',
    RE: 'Report',
    FC: 'Process Sheet',
    FL: 'Flowchart',
    HE: 'Tool',
    MO: 'Template',
    PT: 'Protocol',
    FR: 'Functional Role Sheet',
    FP: 'Position Sheet',
    FG: 'Governance Role Sheet',
  },

  typology: {
    PE: 'Strategic Processes',
    PO: 'Operational Processes',
    PS: 'Support Processes',
  },

  viewer: {
    documentContent: 'DOCUMENT CONTENT',
    searchContent: 'Search in content...',
    cover: 'Cover',
    tabs: {
      content: 'Content',
      metadata: 'Metadata',
      versions: 'Versions',
      references: 'References',
    },
    company: 'Company',
    direction: 'Direction',
    edition: 'Edition',
    date: 'Date',
    process: 'Process',
    elaboratedBy: 'Elaborated by',
    reviewedBy: 'Reviewed by',
    approvedBy: 'Approved by',
    approvalDate: 'Approval date',
    exportPDF: 'Export PDF',
    edit: 'Edit',
    lifecycle: 'Lifecycle',
    outgoing: 'References to',
    incoming: 'Referenced by',
    noReferences: 'No cross-references',
    versionHistory: 'Version history',
    noVersions: 'No versions',
    changeDescription: 'Change description',
    borradorEnEdicion: 'There is a draft in editing',
    verBorrador: 'View draft',
    eliminarBorrador: 'Delete draft',
    confirmarEliminar: 'Delete draft?',
    eliminarBorradorDesc:
      'This action will permanently delete the draft. The published version will not be affected.',
    borradorEliminado: 'Draft deleted',
    eliminar: 'Delete',
    archivar: 'Archive',
    confirmarArchivar: 'Archive document?',
    archivarDesc:
      'The document will be archived and will no longer be active. This action can be reversed.',
    documentoArchivado: 'Document archived',
  },

  editor: {
    save: 'Save',
    close: 'Close',
    saving: 'Saving...',
    saved: 'Saved',
    savedAt: (time: string) => `Saved: ${time}`,
    autosave: 'Autosave every 30s',
    unsavedChanges: 'Unsaved changes',
    addBlock: '+ Add block',
    aiAssistant: '✨ AI Assistant',
    wordCount: (n: number) => `${n} words`,
    generateAI: 'Generate with VALOR·IA',
    generateAIDesc: 'Describe what content you want to generate for this document.',
    generateUnavailable: 'AI generation not available yet. Coming in next version.',
    generatePlaceholder: 'Generate the Definitions section for this procedure...',
    generate: 'Generate',
    insertAtEnd: 'Insert at end',
    insertAtCursor: 'Insert at cursor',
    importDocx: 'Import DOCX',
    dragDocx: 'Drag a .docx file or click to select',
    processingDocx: 'Processing...',
    insertContent: 'Insert content',
    crossRefPlaceholder: 'Search by code (e.g. PE.21.NC)...',
    crossRefNoResults: 'No results. Press Enter to insert manually.',
    crossRefNavigate: 'navigate',
    crossRefSelect: 'select',
    crossRefClose: 'close',
    styles: {
      headings: 'Headings',
      paragraph: 'Paragraph',
      lists: 'Lists',
      table: 'Table',
      character: 'Character',
    },
    toolbar: {
      undo: 'Undo',
      redo: 'Redo',
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      bulletList: 'Bullet list',
      orderedList: 'Numbered list',
      table: 'Table',
      crossRef: 'Cross-reference',
      image: 'Image',
      normNote: 'Normative note',
      codeBlock: 'Code block',
      hr: 'Horizontal line',
      importDocx: 'Import DOCX',
      generateAI: 'Generate with AI',
    },
    table: {
      rowAbove: 'Row above',
      rowBelow: 'Row below',
      colLeft: 'Column left',
      colRight: 'Column right',
      deleteRow: 'Delete row',
      deleteCol: 'Delete column',
      deleteTable: 'Delete table',
      mergeCells: 'Merge cells',
      splitCell: 'Split cell',
    },
    floatingToolbar: {
      improveWriting: 'Improve writing',
      expandContent: 'Expand content',
      summarize: 'Summarize',
      translate: 'Translate ES↔EN',
      verifyCoherence: 'Verify coherence',
      suggestRefs: 'Suggest references',
    },
    aiPanel: {
      title: 'AI Assistant',
      subtitle: 'Document governance',
      draftSection: 'Draft section',
      completeStructure: 'Complete structure',
      verifyCoherence: 'Verify coherence',
      crossRefs: 'Cross-references',
      translate: 'Translate',
      placeholder: 'Type your question...',
    },
    suggestion: {
      accept: 'Accept (Tab)',
      discard: 'Discard',
      regenerate: 'Regenerate',
      badge: '✨ AI Suggestion',
    },
  },

  processSheet: {
    exportPDF: 'Export PDF',
    edit: 'Edit',
    aiAssistant: '✨ AI Assistant',
    sections: {
      identification: 'Identification',
      description: 'Description',
      inputsOutputs: 'Inputs and Outputs',
      reportsRequirements: 'Reports and Requirements',
      documentation: 'Documentation',
      tools: 'Tools',
      indicators: 'Indicators',
    },
    fields: {
      name: 'Name',
      code: 'Code',
      type: 'Type',
      group: 'Functional group',
      responsible: 'Responsible',
      involved: 'Involved',
      scope: 'Scope',
      inputs: 'Inputs',
      outputs: 'Outputs',
      origin: 'Origin',
      destination: 'Destination',
      reports: 'Reports',
      requirements: 'Requirements',
      objective: 'Objective',
      frequency: 'Frequency',
      phase: 'Phase',
    },
    freq: {
      mensual: 'Monthly',
      trimestral: 'Quarterly',
      semestral: 'Biannual',
      anual: 'Annual',
    },
    aiActions: {
      completeDescription: 'Complete description',
      suggestIO: 'Suggest inputs/outputs',
      proposeIndicators: 'Propose indicators',
      verifyCoherence: 'Verify coherence',
      generateSheet: 'Generate full sheet',
    },
    editing: 'Editing...',
    addItem: 'Add',
    removeItem: 'Remove',
    saved: 'Saved',
    noData: 'No data registered',
    placeholders: {
      descripcion: 'Description...',
      unidad: 'Unit...',
      objetivo: 'Target...',
      frecuencia: 'Frequency...',
      destinatario: 'Recipient...',
      codigo: 'Code...',
      modulo: 'V·IAnet module...',
    },
  },

  workflow: {
    sendToReview: 'Send to review',
    sendToApproval: 'Send to approval',
    approve: 'Approve',
    reject: 'Reject',
    publish: 'Publish',
    returnToDraft: 'Return to draft',
    newEdition: 'New edition',
    archive: 'Archive',
    discard: 'Discard',
    reopen: 'Reopen',
    motivoRechazoPrompt: 'Rejection reason (required)',
    motivoRechazoRequerido: 'A reason is required.',
    confirmarAccion: 'Confirm action?',
    // 0665: cross-artifact canonical fields for SEND-FOR-REVIEW.
    asuntoLabel: 'Subject',
    asuntoPlaceholder: 'Brief summary of the change (e.g., "Update approval deadline")',
    asuntoHint: 'Minimum 5 characters · short and clear summary',
    asuntoMinError: 'Subject must be at least 5 characters long.',
    alcanceLabel: 'Scope',
    alcancePlaceholder:
      'Describe what changes, why, and how it will affect the organization (which processes, areas, or people are impacted).',
    alcanceHint: 'Minimum 20 characters · describe what/why/how',
    alcanceMinError: 'Scope must be at least 20 characters long.',
    // 0651: hover hints per workflow action (cross-artifact · shared WorkflowBar).
    hints: {
      enviarRevision:
        'Sends the version to the approver. The approver receives a notification and the version stays pending their decision.',
      aprobar:
        'Confirms the version and leaves it as APPROVED, ready to publish. An SES signature is generated if configured.',
      rechazar:
        'Returns the version to REJECTED state with a reason. The owner can reopen it to fix issues.',
      publicar:
        'Replaces the current published version. The previously published version moves to logical archive.',
      descartar:
        'Permanently abandons the draft. Irreversible action — the version stays as DISCARDED.',
      archivar:
        'Removes the published version from the active list. The version stays as ARCHIVED.',
      reabrir: 'Moves the rejected version back to DRAFT so the owner can edit and resubmit.',
    },
    approvalPreview: {
      willBeSentTo: 'Will be sent to:',
      sourceHierarchy: 'hierarchy',
      sourceProcess: 'process',
      sourceFallback: 'System administration',
    },
    // 0661 ADR-025 ext: cross-artefacto keys for shared ArtefactoWorkflowBar
    // (organigrama + documento + flujograma · unified UI)
    bar: {
      loading: 'Loading workflow…',
      firstEditionDescription: 'First edition',
      createFirstDraft: 'Create draft',
      viewHistory: 'View version history',
      historyButton: (n: number) => `History (${n})`,
      newEditionDescription: (n: number) => `Edition ${n}`,
      newEditionButton: (n: number) => `New edition (Ed. ${n})`,
      historyVersions: 'Version history',
      close: 'Close',
      noVersionsYet: 'No versions yet.',
      onScreen: 'on screen',
      publishedAt: 'Published',
      editionTooltip: (n: number) => `Edition ${n}`,
      viewEditionTooltip: (n: number) => `View edition ${n}`,
      stageBadge: (pos: number, total: number, accion: string) =>
        `Stage ${pos}/${total} · ${accion}`,
      stageTooltip: (pos: number, total: number, accion: string) =>
        `In stage ${pos} of ${total}: ${accion}`,
      errorCreatingDraft: (msg: string) => `Error creating draft: ${msg}`,
      // 0670 — fallback to current published when latest is rejected/discarded + read-only visibility
      fallbackVigenteBadge: 'Latest edition rejected',
      fallbackVigenteTooltip:
        'Latest edition was rejected or discarded · showing the currently published version.',
      soloVigenteBadge: 'Read-only',
      soloVigenteTooltip:
        'You are not part of this approval flow · you can only view the published version.',
      estados: {
        BORRADOR: 'DRAFT',
        EN_REVISION: 'IN REVIEW',
        APROBADO: 'APPROVED',
        PUBLICADO: 'PUBLISHED',
        RECHAZADO: 'REJECTED',
        DESCARTADO: 'DISCARDED',
        ARCHIVADO: 'ARCHIVED',
      },
    },
  },

  modal: {
    newDocument: 'New document',
    selectProcess: 'Select process',
    documentType: 'Document type',
    documentTitle: 'Document title',
    direction: 'Direction',
    edition: 'Edition',
    autoCode: 'Auto-generated code',
    create: 'Create document',
    cancel: 'Cancel',
  },

  quickSearch: {
    placeholder: 'Search documents, processes...',
    recent: 'Recent',
    noResults: 'No results',
    hint: '⌘K to search',
  },

  loading: 'Loading...',
  error: 'Error',
  notFound: 'Not found',
  goBack: 'Go back',

  engineering: {
    organizacional: 'Structure',
    procesos: 'Process',
    informacion: 'Information',
    cumplimiento: 'Compliance',
    tecnologica: 'Tech',
    reputacional: 'Reputation',
  },

  // V·IA Panel & Chat
  via: {
    titulo: 'V·IA — Governance Assistant',
    panel: {
      generar: 'Generate document',
      auditar: 'Audit document',
      traducir: 'Translate',
      mejorar: 'Improve writing',
      ampliar: 'Expand content',
      resumir: 'Summarize',
      verificarTerminos: 'Verify terminology',
      reformular: 'Rephrase',
      definirTermino: 'Define term',
    },
    chat: {
      placeholder: 'Type your query...',
      enviar: 'Send',
      saludo: 'Hello, I am V·IA',
      descripcion:
        'Your corporate governance assistant. I know all processes, documents, people and the organizational structure of the system.',
      hint: 'Ask about processes, documents or regulations.',
      procesando: 'Processing...',
      asistenteListo: 'VIA Assistant ready',
      seleccioneAccion: 'Select a quick action or type a message.',
      errorConexion: 'Connection error with VIA server.',
      errorRed: 'Network error',
      errorServidor: 'Server error',
      accionCompletada: 'Action completed.',
      noDisponible: 'VIA Assistant not available yet.',
      expandir: 'Expand chat',
      contraer: 'Collapse chat',
    },
    contexto: 'Context',
    nuevoContexto: 'New context',
    documentoCompleto: 'Full document',
    accionesRapidas: 'Quick actions',
    sinAcciones: 'No actions available for the current context and role.',
    abrirPanel: 'Open VIA panel',
    cerrarPanel: 'Close panel',
    inteligenciaNormativa: 'Normative artificial intelligence',
    copilot: {
      titulo: 'V·IA Copilot',
      completar: 'Complete this section',
      corregir: 'Review and correct',
      sugerir: 'Suggest improvements',
      verificar: 'Verify compliance',
      aplicar: 'Apply',
      descartar: 'Discard',
      copiar: 'Copy',
    },
  },

  // Suggestions
  sugerencias: {
    titulo: 'Suggestions',
    pendientes: '{{count}} pending suggestion',
    pendientes_plural: '{{count}} pending suggestions',
    aceptar: 'Accept',
    rechazar: 'Reject',
    aceptarTodas: 'Accept all',
    rechazarTodas: 'Reject all',
    siguiente: 'Next',
    aceptarSugerencia: 'Accept suggestion',
    rechazarSugerencia: 'Reject suggestion',
  },

  // Topbar (notifications bell, dropdown panel)
  topbar: {
    notifications: {
      title: 'Notifications',
      empty: 'No notifications',
      markAllRead: 'Mark all read',
      sectionPendientes: 'Live pending',
      sectionNotificaciones: 'Notifications',
      tooltipBell: 'Notifications',
      tagOrganigrama: 'Org chart',
      tagDocumento: 'Document',
      tagFlujograma: 'Flowchart',
      tagProceso: 'Process',
    },
  },

  // Admin
  admin: {
    titulo: 'Administration',
    dashboardTitle: 'Administration panel',
    tooltips: {
      dashboard: {
        titulo: 'Administration panel',
        ayuda:
          'Control centre for the V·IAnet Governance platform.\n\nFrom here you can configure the company, manage users and roles, activate modules and monitor AI usage.\n\nChanges in this section affect all tenant users.',
      },
    },
    tabs: {
      dashboard: 'Dashboard',
      backoffice: 'Backoffice',
      empresa: 'Company',
      usuarios: 'Users',
      modulos: 'Modules',
      plataforma: 'Platform',
      ia: 'Artificial Intelligence',
      notificaciones: 'Notifications',
      sign: 'Sign',
      workflows: 'Approval workflows',
      i18n: 'Languages',
    },
    dashboard: {
      totalUsuarios: 'Active Users',
      totalDocumentos: 'Documents',
      totalProcesos: 'Processes',
      publicados: 'Published',
      modulos: 'Modules',
      totalFlujogramas: 'Flowcharts',
      totalAuditorias: 'Audits',
      actividadReciente: 'Recent activity',
      sinActividad: 'No recent activity',
      saludSistema: 'System health',
      baseDatos: 'Database',
      operativo: 'Operational',
      degradado: 'Degraded',
      caido: 'Down',
      desconocido: 'Unknown',
      planYUso: 'Plan & usage',
      modulosActivos: '13 active modules',
      tokensIA: 'AI Tokens',
      auditoria: 'Audit log',
      filtrarUsuario: 'Filter user...',
      exportarCSV: 'CSV',
      fecha: 'Date',
      usuario: 'User',
      accion: 'Action',
      entidad: 'Entity',
      reindexar: 'Reindex Meilisearch',
    },
    empresa: {
      pills: {
        brand: 'Brand Identity',
        regional: 'Regional',
        templates: 'Templates',
        governance: 'Governance',
        auth: 'Authentication',
      },
      formatoFecha: 'Date format',
      proximamente: 'Feature under development. Coming soon.',
    },
    plataforma: {
      pills: {
        modules: 'Modules & plan',
        apps: 'V·IAnet Apps',
        plan: 'Plan & Limits',
      },
      appsTitle: 'V·IAnet Apps (M12)',
      appsDesc: 'Sub-apps of M12 V·IAnet Apps. Only enabled if M12 is active.',
      planCardTitle: 'Tenant plan and limits',
      planLabel: 'Licensing plan',
      maxUsuariosLabel: 'Maximum users',
      dominioLabel: 'Custom domain',
      dominioHint:
        'Empty = use default domain. Requires DNS CNAME pointing to app.valoriagovernance.com.',
      planSaveBtn: 'Save changes',
      planSaving: 'Saving...',
      planSaveOk: 'Plan and limits updated successfully',
      planSaveErr: 'Error saving plan',
      appUpdateErr: 'Error updating app',
    },
    ia: {
      pills: {
        status: 'Status & usage',
        config: 'Configuration',
        chat: 'VALORIA Chat',
        assist: 'VALORIA Assist',
        providers: 'Providers',
        instructions: 'Instructions',
        evals: 'Evaluations',
      },
      sinDatos: 'No consumption data available',
      proximamente: 'Feature under development. Coming soon.',
      systemPrompt: 'Custom system prompt',
      systemPromptPlaceholder: 'Custom instructions for the tenant AI assistant...',
      proveedores: {
        titulo: 'Providers and models',
        ayuda:
          'Which AI providers does the system have available?\n\nHere you configure each one: its API key, connection URL, and the model it will use by default. Most are cloud services (Mistral, Groq, NVIDIA…), but Ollama is special — it runs on your own computer without sending data anywhere.\n\nBefore activating a provider, click "Test" to confirm the connection is working.',
      },
      chat: {
        titulo: 'Chat configuration',
        ayuda:
          'Who answers when you ask a question in V·IA?\n\nThe main provider is tried first. If it fails or reaches its usage limit, the system automatically moves to the next one in the fallback chain — completely transparent to the user.\n\nThe "Reindex" button updates the RAG search index with the most recently published documents in the system.',
      },
      modos: {
        titulo: 'Assistant modes',
        ayuda:
          'V·IA works differently depending on what you need:\n\n· Generation — creates new content from an instruction.\n· Correction — reviews and improves an existing text.\n· Audit — verifies regulatory compliance of a document.\n· Translation — adapts content to another language.\n\nYou can assign a different model to each mode to balance speed, cost, and quality.',
      },
      rag: {
        titulo: 'RAG index status',
        ayuda:
          'What is the RAG index?\n\nThe system searches documents by converting text into mathematical vectors (embeddings). This index is generated once and reused in every query.\n\n· "Changes only" — reindex only documents modified since the last indexing. Fast and without exhausting the Gemini quota.\n· "Everything" — reindex all documents from scratch. Useful if you suspect the index is corrupted or incomplete.\n\nAutomatic reindexing runs at server startup and every 30 minutes in the background.',
        soloCambios: 'Changes only',
        todo: 'Everything',
        reindexar: 'Reindex',
        indexando: 'Indexing...',
        ultimaIndexacion: 'Last indexed',
        autoCada: 'Automatic reindex every',
        minutos: 'minutes',
        ultimosCiclos: 'Last reindex cycles',
      },
    },
    notificaciones: {
      titulo: 'Notification Preferences',
      evento: 'Event',
      email: 'Email',
      push: 'Push',
      inApp: 'In-App',
      guardar: 'Save preferences',
      guardado: 'Notification preferences saved',
      canales: {
        titulo: 'Notification channels',
        descripcion:
          'Configure outbound providers so workflow NOTIFY stages reach external recipients.',
        mailTitulo: 'Email (Resend)',
        mailDescripcion: 'Email notifications via Resend',
        mailHabilitar: 'Enable email',
        mailFromEmail: 'From email',
        mailApiKey: 'Resend API key',
        teamsTitulo: 'Microsoft Teams',
        teamsHabilitar: 'Enable Teams',
        teamsWebhook: 'Incoming webhook URL',
        slackTitulo: 'Slack',
        slackHabilitar: 'Enable Slack',
        slackWebhook: 'Incoming webhook URL',
        modoSandbox: 'Sandbox mode (does not send, only logs)',
        modoSandboxDescripcion:
          'When active, providers log but do not send. Useful for safe deploys.',
        cambiar: 'Change',
        limpiar: 'Clear',
        credencialGuardada: 'Credential saved',
        credencialAusente: 'No credential',
        nuevoValor: 'New value',
        guardado: 'Configuration saved',
        errorGuardar: 'Error saving configuration',
        // ADR-027.3 (0658c): Test channel button + inline audit trail keys
        test: {
          botonProbar: 'Test channel',
          enviando: 'Sending...',
          exito: '✓ Message sent successfully',
          error: '✕ Error: {detalle}',
          mensajeEnviadoEn: 'Sent at {timestamp}',
          messageId: 'ID: {id}',
          reasonNoProvider: 'Credential not configured',
          reasonProviderError: 'Provider error',
          reasonSandboxMode: 'Sandbox mode active',
          confirmarTest:
            'Send test message to current admin email? A real message will be sent (bypasses sandbox mode).',
        },
      },
    },
    secciones: {
      usuarios: 'Users',
      roles: 'Roles & Permissions',
      procesos: 'Processes',
      modulos: 'Modules',
      via: 'Artificial Intelligence',
      configuracion: 'Settings',
      auditoria: 'Audit',
    },
    usuarios: {
      nombre: 'Name',
      email: 'Email',
      rol: 'Role',
      estado: 'Status',
      ultimoAcceso: 'Last access',
      crear: '+ New user',
      editar: 'Edit',
      desactivar: 'Deactivate',
      activo: 'Active',
      inactivo: 'Inactive',
      sinUsuarios: 'No users',
      gestionarUsuarios: 'Manage tenant users',
      nuevoUsuario: 'New user',
      nombreCompleto: 'Full name',
      crearUsuario: 'Create user',
      creando: 'Creating...',
      emailNombreObligatorios: 'Email and name are required',
      creadoCorrectamente: 'User created successfully',
      desactivado: 'User deactivated',
      confirmarDesactivar: 'This user will be deactivated. Continue?',
      creado: 'Created',
      // 0577 + 0580 + 0583
      cambiarRolTitulo: 'Change user role',
      cambiarRolUsuarioLabel: 'User',
      cambiarRolActual: 'Current role',
      cambiarRolNuevo: 'New role',
      cambiarRolHelp: 'Only SUPERADMIN_PLATFORM can assign SUPERADMIN_PLATFORM. Backend validates.',
      guardarCambios: 'Save changes',
      guardando: 'Saving...',
      cancelar: 'Cancel',
      readOnlyBanner: 'Read-only view. Your role does not allow inviting or modifying users.',
      copyPasswordTitulo: 'User created - Copy temporary password',
      copyPasswordHelp:
        'Automated email is not configured. Copy this password and securely deliver it to {email}. It will not be shown again.',
      copiar: 'Copy',
      cerrar: 'Close',
      passwordCopiada: 'Password copied to clipboard',
      empresaReadOnly: 'Read-only view. Your role does not allow modifying company settings.',
      iaReadOnly: 'Read-only view. Your role does not allow modifying AI settings.',
      // 0586
      cargosOrganigramaInfo:
        'Governance roles (corporate org chart positions) are not system RBAC roles. They are managed in the Structure module.',
      cargosOrganigramaLink: 'Go to Structure',
      // 0600
      tuBadge: '(you)',
      superadminTenantBanner:
        "You're viewing only your internal tenant users (VALOR·IA). To manage other tenants users go to {link} and use Impersonate.",
      superadminTenantBannerLink: 'Backoffice',
      gestionar: 'Manage',
      exportarCsv: 'Export CSV',
      exportando: 'Exporting...',
      importarCsv: 'Import CSV',
      importando: 'Importing...',
      invitar: '+ Invite',
      invitarTitulo: 'Invite new user',
      invitarRolLabel: 'Assigned role',
      invitarEnviar: 'Send invitation',
      enviando: 'Sending...',
      noUsuariosSeleccionados: '0 users',
      mostrandoCount: 'Showing {from}-{to} of {total}',
      porPagina: 'Per page:',
      modalDatosBasicos: 'Basic data',
      modalPermisos: 'Permissions & access',
      modalAcciones: 'Actions',
      modalEmailHelp: 'Email cannot be changed here (affects login).',
      modalPersonaLabel: 'Org chart person (M1 Structure)',
      modalSinVincular: '— Unlinked —',
      modalUltimoAcceso: 'Last access',
      modalSelfBanner:
        "You can't change your own role nor deactivate/delete yourself. You can only edit name and linked person.",
      modalAdminOwnerBanner:
        'TENANT_ADMIN cannot modify a TENANT_OWNER. Only TENANT_OWNER or SUPERADMIN_PLATFORM can.',
      resetearContrasena: 'Reset password',
      eliminarUsuario: 'Delete user',
      lockoutBloqueada: 'Account locked',
      lockoutIntentos: '{n} failed attempt(s)',
      lockoutMaximo: 'Maximum 5 before automatic 15 min lockout.',
      lockoutDesbloquearAuto: 'Automatic unlock in {min} min.',
      lockoutTrasIntentos: 'After {n} failed attempts.',
      desbloquear: 'Unlock',
      bulkSeleccionados: '{n} user(s) selected',
      bulkLimpiar: 'Clear',
      bulkActivar: 'Activate',
      bulkDesactivar: 'Deactivate',
      bulkEliminar: 'Delete',
      confirmar: 'Confirm',
      confirmActivar: 'Activate users',
      confirmDesactivar: 'Deactivate users',
      confirmEliminar: 'Delete users',
      personaVinculadaCount: '{n} people in the tenant catalog.',
    },
    roles: {
      titulo: 'Roles & Permissions',
      matrizPermisos: 'RBAC permission matrix by role',
      permiso: 'Permission',
    },
    procesos: {
      titulo: 'Processes',
      vistaGeneral: 'Process map overview for the tenant',
      total: 'Total',
      estrategicos: 'Strategic',
      operativos: 'Operational',
      soporte: 'Support',
      activos: 'Active',
      filtrar: 'Filter by:',
      todos: 'All',
      cargando: 'Loading processes...',
    },
    modulos: {
      titulo: 'Modules',
      estadoModulos: 'V·IAnet module status for the tenant',
      soloPlatformPuedeActivar:
        'Only the VALOR·IA platform can activate or deactivate modules. Read-only view.',
      total: 'Total',
      activos: 'Active',
      inactivos: 'Inactive',
      cargando: 'Loading modules...',
      descriptions: {
        M1: 'Interactive Org Charts',
        M2: 'Process Map',
        M3: 'Flowcharts',
        M4: 'Document Management',
        M5: 'Smart Search',
        M6: 'Version Control & Approval',
        M7: 'Audit',
        M8: 'Administration & RBAC',
        M9: 'Artificial Intelligence API',
        M10: 'Governance Virtual Assistant',
        M11: 'Governance Dashboards',
        M12: 'Process Digitalization Apps',
        M13: 'Internal Communications',
        M14: 'Mobile App',
        M15: 'Electronic Signature',
        M16: 'Requests & Approvals',
        M17: 'Multi-channel Notifications',
        M18: 'Multilingual Support',
        M19: 'ISO 31000 Risk Management',
        M20: 'Internal Helpdesk & Support',
      },
      proximamente: 'Coming soon',
      activado: 'enabled',
      desactivado: 'disabled',
      requiere: 'requires',
      dependeDe: 'depends on',
    },
    i18n: {
      titulo: 'Language Management',
      descripcion: 'System translation keys overview across 3 supported languages',
      clavesTotal: 'total keys',
      sinTraducirEN: 'missing EN',
      sinTraducirZH: 'missing ZH',
      buscar: 'Search by key or text...',
      soloSinTraducir: 'Missing only',
      clave: 'Key',
      falta: 'Missing',
      mostrando: 'Showing',
      sinResultados: 'No results',
    },
    via: {
      titulo: 'Artificial Intelligence',
      configuracion: 'V·IA configuration and token consumption',
      proveedor: 'AI Provider',
      modelo: 'Model',
      consumo: 'Token consumption',
      limite: 'Monthly limit',
      usados: 'Tokens used',
      restantes: 'Tokens remaining',
      consumoMes: 'Current month consumption',
      consumoHistorico: 'Historical consumption',
      configuracionModelos: 'Model configuration',
      proveedorTraducciones: 'Translation provider',
      proveedorTraduccionesAuto: 'Automatic (local Gemma → fallback)',
      proveedorTraduccionesHint:
        'Used to automatically translate data to EN and ZH when content is created or edited.',
      apiKeyPropia: 'Own API Key (optional)',
      apiKeyDescripcion: 'If provided, this key will be used instead of the shared V·IANet key.',
      guardarConfigIA: 'Save AI configuration',
      configGuardada: 'AI configuration saved',
      cargando: 'Loading AI configuration...',
      utilizado: 'used',
      temperatura: 'Temperature',
      maxTokens: 'Max Tokens',
    },
    config: {
      titulo: 'Settings',
      descripcion: 'Tenant, brand and module settings',
      identidadMarca: 'Brand Identity',
      general: 'General',
      modulos: 'Modules',
      marca: 'Brand',
      nombreMarca: 'Brand Name',
      fuente: 'Font',
      colores: 'Colors',
      primario: 'Primary',
      secundario: 'Secondary',
      acento: 'Accent',
      vistaPrevia: 'Preview',
      logos: 'Logos',
      logoPrincipal: 'Main logo',
      logoHeader: 'Header logo',
      favicon: 'Favicon',
      guardarCambios: 'Save changes',
      archivoActualizado: 'File updated',
      configGuardada: 'Settings saved',
      cargando: 'Loading settings...',
      configuracionGeneral: 'General Settings',
      idioma: 'Language',
      zonaHoraria: 'Timezone',
      dominio: 'Custom domain',
      plan: 'Plan',
      modulosActivos: 'Active modules',
      guardarModulos: 'Save modules',
      guardando: 'Saving...',
      errorAlSubirArchivo: 'Error uploading file',
    },
    auditoria: {
      titulo: 'Audit',
      registroActividad: 'System activity log',
      entidad: 'Entity',
      accion: 'Action',
      desde: 'From',
      hasta: 'To',
      todas: 'All',
      fecha: 'Date',
      usuario: 'User',
      evento: 'Event',
      detalle: 'Detail',
      cargando: 'Loading...',
      sinRegistros: 'No records',
      anterior: 'Previous',
      siguiente: 'Next',
      sistema: 'System',
    },

    // 0658a — Workflow notification templates (ADR-027.1)
    workflow: {
      plantillas: {
        tituloEditor: 'Templates editor',
        tabIn_app: 'In-app',
        tabEmail: 'Email',
        tabTeams: 'Teams',
        tabSlack: 'Slack',
        labelAsunto: 'Subject',
        labelCuerpo: 'Body',
        idiomaEs: 'Spanish',
        idiomaEn: 'English',
        idiomaZh: 'Chinese',
        variablesDisponibles: 'Available variables',
        placeholderAsunto: 'Ex: New edition of {{artefactoTitulo}}',
        placeholderCuerpo: 'Message body. Use {{variables}} to personalize.',
        botonGuardar: 'Save template',
        botonActiva: 'Template active',
        botonAnadirEditor: 'Edit templates',
        actionTooltipNotificar: 'Auto-processed notification (no approval required)',
        selectOptionRevisar: 'REVIEW',
        selectOptionAprobar: 'APPROVE',
        selectOptionNotificar: 'NOTIFY',
        cargando: 'Loading...',
        cerrar: 'Close',
      },
    },
  },

  // Tenant Selector
  tenantSelector: {
    subtitle: 'Select the organization you want to access',
    selectTenant: 'Available organizations',
  },

  // Onboarding Wizard
  onboarding: {
    steps: ['Welcome', 'Company data', 'Logo & brand', 'Initial users', 'Completed'] as string[],
    stepLabel: (current: number, total: number) => `Step ${current} of ${total}`,
    welcomeTitle: 'Welcome to V·IANet Governance',
    welcomeDesc:
      'In the following steps we will set up your organization on the platform. This wizard will guide you through basic data, visual identity and initial users.',
    companyTitle: 'Company data',
    companyName: 'Company name',
    companyNamePlaceholder: 'My Company Inc.',
    industry: 'Industry / Sector',
    industryPlaceholder: 'Technology, Finance, Energy...',
    country: 'Country',
    countryPlaceholder: 'Spain',
    employees: 'Employees',
    brandTitle: 'Logo & brand',
    logo: 'Organization logo',
    dropLogo: 'Drag an image or click to select',
    primaryColor: 'Primary color',
    secondaryColor: 'Secondary color',
    accentColor: 'Accent color',
    usersTitle: 'Initial users',
    usersDesc:
      'Invite the first users to your organization. You can add more from the admin panel.',
    email: 'Email',
    role: 'Role',
    completeTitle: 'Setup completed',
    completeDesc:
      'Your organization is ready. You can start using V·IANet Governance and configure the corporate governance modules.',
    goToPanel: 'Go to admin panel',
  },

  // Backoffice
  backoffice: {
    titulo: 'Backoffice — Platform Management',
    gestionTenants: 'Platform tenants',
    descripcion: 'Centralized management of all organizations registered on V·IANet Governance.',
    crearTenant: 'Create tenant',
    usingPlaceholder: 'Could not connect to the service. Showing sample data.',
    columns: {
      nombre: 'Name',
      plan: 'Plan',
      usuarios: 'Users',
      docs: 'Documents',
      estado: 'Status',
      acciones: 'Actions',
    },
    addAdmin: {
      btn: '+ Admin',
      btnEliminar: 'Delete',
      titulo: 'Add admin to',
      subtitulo:
        'A user with CEO role will be created in this tenant. You will receive a temporary password to give to the client admin.',
      email: 'Admin email',
      emailPlaceholder: 'admin@company.com',
      nombre: 'Full name',
      nombrePlaceholder: 'John Doe',
      cancelar: 'Cancel',
      crear: 'Create admin',
      creando: 'Creating…',
      exitoTitulo: 'Admin created!',
      exitoDescripcion:
        'Copy the temporary password and give it to the client. For security reasons you will not be able to see it again.',
      passwordLabel: 'Temporary password',
      copiarPassword: 'Copy',
      copiado: 'Copied!',
      cerrar: 'Close',
      confirmEliminarTitulo: 'Delete tenant?',
      confirmEliminarDesc: (nombre: string) =>
        `You are about to delete "${nombre}" and all its data (users, AI configuration, audit log). This action CANNOT be undone.`,
      confirmEliminarBtn: 'Yes, delete',
    },
    impersonate: {
      btn: 'Sign in as',
      banner: 'You are impersonating {tenant} (original session: {email}) ·',
      bannerVolver: 'Back to my account',
      confirmTitulo: 'Sign in as admin of this tenant?',
      confirmDesc: (nombre: string) =>
        `You are about to enter the "${nombre}" tenant account for 1 hour. Every action will be logged in audit with your original identity.`,
      confirmBtn: 'Yes, sign in',
      error: 'Failed to start impersonation session.',
    },
    wizard: {
      titulo: 'Create new tenant',
      subtitulo: 'Complete the 3 steps to register a new organization on the platform',
      step0Label: 'Identification',
      step1Label: 'Configuration',
      step2Label: 'Branding',
      nombre: 'Organization name',
      nombrePlaceholder: 'Grupo Puentes, Acme Corp...',
      slugHint: 'Unique identifier for the organization. Letters, numbers and hyphens only.',
      plan: 'Plan',
      maxUsuarios: 'Max. users',
      modulos: 'Active modules',
      modulosSeleccionados: 'modules selected',
      idioma: 'Default language',
      formatoFecha: 'Date format',
      zonaHoraria: 'Time zone',
      colorPrimario: 'Primary color',
      colorSecundario: 'Secondary color',
      colorAcento: 'Accent color',
      fuente: 'Typography',
      preview: 'Preview',
      exitoTitulo: 'Tenant created successfully!',
      exitoDescripcion: 'The organization has been registered on the platform.',
      volverBackoffice: 'Back to backoffice',
      anterior: 'Previous',
      siguiente: 'Next',
      crear: 'Create tenant',
      creando: 'Creating...',
    },
  },

  // Import document
  importar: {
    titulo: 'Import Document',
    descripcion: 'Upload a .docx or .pdf file to import its content into the system',
    arrastrar: 'Drag a file here or click to select',
    oSeleccionar: 'Supported formats: .docx, .pdf (max. 50 MB)',
    procesando: 'Processing file...',
    previsualizacion: 'Preview',
    confirmar: 'Confirm Import',
    cancelar: 'Cancel',
    importando: 'Importing document...',
    creandoDocumento: 'Creating document, version and structure in database',
    exito: 'Document imported successfully',
    importarOtro: 'Import another',
    verDocumento: 'View document',
    reintentar: 'Retry',
    metadatos: 'Document Metadata',
    codigo: 'Code',
    nombre: 'Name',
    tipoDocumental: 'Document Type',
    proceso: 'Process',
    edicion: 'Edition',
    archivo: 'File',
    seleccione: 'Select...',
    autoDetectar: 'Auto-detect from code',
    estructuraDetectada: 'Detected Structure',
    secciones: 'sections',
    bloques: 'blocks',
    seccionVacia: '(empty section)',
    advertencias: 'Warnings',
    completarCampos: 'Complete all required fields',
    soloDocxPdf: 'Only .docx and .pdf files are accepted',
    errorParsear: 'Error parsing file',
    errorConfirmar: 'Error confirming import',
  },

  // Common
  common: {
    dictado: {
      dictar: 'Dictate',
      detener: 'Stop',
      transcribiendo: 'Transcribing…',
      noSoportado: 'Your browser does not support audio recording',
      sinPermiso: 'No microphone access',
      error: 'Could not transcribe',
    },
    persona: {
      cargando: 'Loading person…',
      noEncontrada: 'Person not found',
      puestoUnknown: 'No active position',
    },
    guardar: 'Save',
    cancelar: 'Cancel',
    cerrar: 'Close',
    eliminar: 'Delete',
    editar: 'Edit',
    crear: 'Create',
    buscar: 'Search...',
    cargando: 'Loading...',
    error: 'Error',
    exito: 'Success',
    confirmar: 'Confirm',
    volver: 'Back',
    siguiente: 'Next',
    anterior: 'Previous',
    guardando: 'Saving...',
    acciones: 'Actions',
    ver: 'View',
    nombre: 'Name',
    tipo: 'Type',
    estado: 'Status',
    codigo: 'Code',
    fecha: 'Date',
    searchPlaceholder: 'Search...',
    rejectionReason: 'Enter rejection reason...',
    documentName: 'Document name',
    nodeName: 'Node name',
    nodeDescription: 'Node description',
    noPhase: 'No phase',
    selectPosition: 'Select position...',
    selectDocument: 'Select document...',
    selectProcess: 'Select process...',
    examplePolicy: 'e.g. Quality Policy',
    processDescription: 'Process description...',
    processScope: 'Process scope...',
    exampleChangelog: 'e.g.: Updated section 5.3 to incorporate the new approval flow...',
    processCode: 'Process code (e.g.: PE.21)',
    companyName: 'Company name',
    exampleCode: 'PE.21.NC.01',
    basePath: 'C:\\Documents\\Process Map',
    conditionExample: 'e.g.: Approved?',
    descripcion: 'Description',
    enDesarrollo: 'This feature is under development',
    loadingDocument: 'Loading document...',
    documentNotFound: 'Document not found',
    discard: 'Discard',
    closeEditor: 'Close editor',
    newEditionBtn: '+ New Ed.',
    documentSaved: 'Document saved',
    errorSaving: 'Error saving: ',
    changesDiscarded: 'Changes discarded',
    statusUpdated: 'Status updated successfully',
    newEditionCreated: 'New edition created',
    errorNewEdition: 'Error creating new edition',
    discardChanges: 'Discard changes',
    discardWarning: 'All changes since last save will be lost. This action cannot be undone.',
    autoSave: 'Auto-save:',
    noContent: 'This document has no content yet.',
    processing: 'Processing...',
    creating: 'Creating...',
    selectDocFromList: 'Select a document from the list to view it here',
    style: 'Style...',
    page: 'Page',
    nuevaEdicionBtn: '+ New Edition',
    errorTransicion: 'Transition error',
    errorDescartar: 'Error discarding changes',
    errorCargarDocumento: 'Error loading document',
    errorDesconocido: 'Unknown error',
    noTieneContenido: 'This document has no content yet.',
    descartarCambiosDialogTitle: 'Discard changes',
    descartarCambiosDialogDesc:
      'All unsaved changes in the editor will be lost. This action cannot be undone.',
    accionNoValida: (accion: string, estado: string) =>
      `Action "${accion}" is not valid for the current state "${estado}"`,
    expandir: 'Expand',
    negrita: 'Bold',
    cursiva: 'Italic',
    titulo1: 'Heading 1',
    titulo2: 'Heading 2',
    titulo3: 'Heading 3',
    listaConVinetas: 'Bullet list',
    listaNumerada: 'Numbered list',
    insertarTabla: 'Insert table',
    deshacer: 'Undo',
    rehacer: 'Redo',
    viaAsistente: 'V·IA Assistant',
    sinSeleccion: '--',
    pagination: {
      anterior: 'Previous',
      siguiente: 'Next',
      pageOf: (page: number, total: number) => `Page ${page} of ${total}`,
    },
    estados: {
      activo: 'Active',
      inactivo: 'Inactive',
    },
  },

  // Role labels
  roles: {
    CEO: 'General Management',
    COO: 'Operations Management',
    CTO: 'Technology Management',
  },

  // Structure module (M1)
  structure: {
    title: 'Organizational Structure',
    description:
      'Org charts, positions, hierarchical and functional relationships. Defines the organizational architecture and corporate governance bodies.',
    puestosTitle: 'Position catalogue',
    personasTitle: 'People directory',
    tooltips: {
      departamentosArbol: {
        titulo: 'Organizational structure',
        ayuda:
          'Represents the hierarchy of organizational units for the tenant.\n\n· Click any node to see its details and assigned people.\n· Greyed-out nodes correspond to inactive units.\n· The structure reflects the organizational model configured in administration.',
      },
      adminPersonas: {
        titulo: 'People management',
        ayuda:
          'Directory of people, positions and roles for the tenant.\n\nEach person can hold multiple positions. Positions belong to functional roles that define responsibilities in governance processes.\n\nChanges here affect the responsible parties assigned to processes and documents.',
      },
      puestos: {
        titulo: 'Positions catalogue',
        ayuda:
          'List of all positions defined in the organization.\n\nEach position belongs to a functional role and may have one or more people assigned. Positions are the unit for assigning responsibilities in processes and documents.',
      },
      personas: {
        titulo: 'People directory',
        ayuda:
          'All people registered in the system with their positions and departments.\n\nUse filters to find people by department, role or status. Click a person to see their full profile and their responsibilities in processes and documents.',
      },
      glosario: {
        titulo: 'Corporate glossary',
        ayuda:
          'Repository of terms and definitions of the governance system.\n\nGlossary terms are used in documents, processes and sheets to ensure a common language across the organization.',
      },
      misSolicitudes: {
        titulo: 'My requests',
        ayuda:
          'Requests you have created or where you participate as approver or involved party.\n\nYou can see the status of each request, pending steps and the history of actions performed.',
      },
    },
    // FichaPersonalViewer (FP/FR)
    ficha: {
      tipoBadgeFP: 'JOB DESCRIPTION',
      tipoBadgeFR: 'FUNCTIONAL ROLE',
      guardando: 'Saving…',
      guardado: 'Saved ✓',
      sinRelaciones: '(No hierarchical relationships defined)',
      sinRoles: '(No governance roles assigned)',
      workflow: {
        enviarRevision: 'Send to review',
        aprobar: 'Approve',
        iniciarFirma: 'Start signing',
        iniciandoFirma: 'Starting…',
        reintentar: 'Retry',
        errorFirma: 'Error starting signature',
        firmaSolicitada: 'Signature request sent',
        firmaSolicitadaN: (n: number) => `Request sent to ${n} approver${n !== 1 ? 's' : ''}`,
      },
    },
    descriptions: {
      orgChart: 'Visualize and edit the organizational hierarchy',
      organizations: 'Manage corporate group entities',
      people: 'People directory and talent management',
      governance: 'Governance analysis and management bodies',
    },
    tabs: {
      orgChart: 'Org Chart',
      organizations: 'Organizations',
      people: 'People',
      governance: 'Governance',
      analytics: 'Analytics',
      positions: 'Positions',
      departments: 'Departments',
      admin: 'Administration',
    },
    analytics: {
      title: 'People Analytics',
      comingSoon: 'Coming soon',
      tabs: { governance: 'Governance', business: 'Business' },
      governance: {
        coverageRate: 'Role coverage',
        vacancies: 'Vacancies',
        criticalVacancies: 'with critical roles',
        activeRoles: 'Active roles',
        inPositions: 'in positions',
        busFactor: 'Bus factor',
        personsMultiRole: 'persons with 2+ roles',
        jobDescriptions: 'Job descriptions',
        completed: 'completed',
        occupancyRate: 'Occupancy rate',
        withoutPosition: 'Without position',
        departments: 'Departments',
        withActivePeople: 'with active people',
        roleConcentration: 'Role concentration (bus factor)',
        rolesByType: 'Governance roles by type',
        coverageByLevel: 'Coverage by hierarchical level',
        alerts: 'Governance alerts',
        detailTable: 'Person details',
        clearFilters: 'Clear filters',
        activeFilters: 'Active filters',
        noResults: 'No persons found with the applied filters.',
        noData: 'No data',
        noDataDesc: 'No governance data available.',
        fichasPuesto: 'Job descriptions',
        noPuesto: 'Without position',
        busFactorChart: 'Role concentration (bus factor)',
        loading: 'Loading governance data...',
        error: 'Error loading governance data.',
      },
      business: {
        title: 'Business',
        totalPeople: 'Active people',
        recentHires: 'last 3 months',
        evolution: 'Hiring evolution',
        monthlyHires: 'Monthly hires',
        cumulative: 'Cumulative',
        companies: 'Companies',
        sites: 'Sites',
        positions: 'Positions',
        countries: 'Countries',
        departments: 'Departments',
        byDepartment: 'Employees by department',
        byPosition: 'Employees by position',
        byCompany: 'By company',
        bySite: 'By work site',
        byCountry: 'By country',
        directory: 'Directory',
        filters: 'Filters',
        clearFilters: 'Clear filters',
      },
      unified: {
        title: 'People Analytics',
        loading: 'Loading People Analytics...',
        coverageRoles: 'Coverage',
        vacancies: 'Vacancies',
        busFactor: 'Bus factor',
        activeRoles: 'Roles',
        jobDescriptions: 'Job desc.',
        occupancy: 'Occupancy',
        activePeople: 'People',
        companies: 'Companies',
        positions: 'Positions',
        departments: 'Departments',
        countries: 'Countries',
        recentHires: 'Hires 3m',
        busFactorChart: 'Bus factor',
        rolesByType: 'Roles by type',
        evolution: 'Evolution',
        byDepartment: 'By department',
        coverageByLevel: 'Coverage level',
        alerts: 'Alerts',
        vacancyDistribution: 'Vacancies',
        byCompany: 'By company',
        bySite: 'By site',
        byCountry: 'By country',
        detailTable: 'People directory',
        clearFilters: 'Clear filters',
        superior: 'Manager',
        byPosition: 'By position',
      },
    },
    orgChart: {
      title: 'Corporate Organization Chart',
      vertical: 'Vertical',
      horizontal: 'Horizontal',
      exportPdf: 'Export PDF',
      exporting: 'Exporting...',
      fullscreen: 'Fullscreen',
      exitFullscreen: 'Exit',
      editOrgChart: 'Edit org chart',
      saveAndExit: 'Save and exit',
      discardChanges: 'Discard changes',
      discardChangesConfirm: 'Discard all org chart changes? This action cannot be undone.',
      closeEditMode: 'Close',
      loadingOrgChart: 'Loading org chart...',
      editMode: 'EDIT',
      editHelp:
        'Drag nodes to move them. Connect handles to create relations. Right-click for more options.',
      resetLayout: 'Reset automatic layout',
      backToFull: 'Back to full org chart',
      newPuesto: '+ New position',
      totalPuestos: 'Total positions',
      vacantes: 'Vacancies',
      personasAsignadas: 'Assigned persons',
      editModeActive: 'Edit mode active',
      semanticZoom: 'Semantic zoom',
      errorLoadPuesto: 'Error loading position',
      close: 'Close',
      viewPersonProfile: 'View full profile',
      layerNone: 'No layer',
      layerGovernance: 'Governance roles',
      layerVacancies: 'Vacancies',
      layerLevels: 'Levels',
      legend: 'Legend',
      vacantCritical: 'Vacant with critical role',
      viewInOrgChart: 'View in org chart',
      searchPlaceholder: 'Search person or position...',
      legendNiveles: 'Levels',
      noResults: 'No results',
      // 0651: WorkflowBar + org chart viewer strings (migrated from hardcoded).
      loadingWorkflow: 'Loading workflow…',
      historyVersions: 'Version history',
      noVersionsYet: 'No versions yet.',
      viewHistory: 'View version history',
      historyButton: (n: number) => `History (${n})`,
      editionNumber: (n: number) => `Edition ${n} of the org chart`,
      editButtonDisabledTooltip: 'Create a new edition first — you can only edit DRAFT versions.',
    },
    drawer: {
      info: 'Information',
      nivel: 'Level',
      departamento: 'Department',
      organizacion: 'Organization',
      assignedPerson: 'Assigned person',
      vacant: 'Vacant',
      chainOfCommand: 'Chain of command',
      subordinates: 'Subordinates',
      moreItems: (n: number) => `+${n} more...`,
      governanceRoles: 'Governance roles',
      viewFicha: 'View position sheet',
      noFicha: 'No sheet',
      viewInOrgChart: 'View in org chart',
    },
    fichaLabel: 'Sheet',
    editPuesto: 'Edit position',
    assignPerson: 'Assign person',
    createSubordinate: 'Create subordinate',
    createRelation: 'Create relation',
    deletePuesto: 'Delete position',
    confirmDeletePuesto:
      'Are you sure you want to delete this position? This action cannot be undone.',
    errorDeletePuesto: 'Error deleting position',
    deleteRelation: 'Delete relation',
    newRelation: 'New relation',
    relationType: 'Relation type',
    solidRelation: 'Solid (direct hierarchy)',
    dottedRelation: 'Dotted (indirect report)',
    functionalRelation: 'Functional',
    projectRelation: 'Project (temporary)',
    isPrimaryRelation: 'Is primary relation',
    createRelationBtn: 'Create relation',
    newPuestoTitle: 'New position',
    titleRequired: 'Title is required',
    errorCreatePuesto: 'Error creating position',
    tituloLabel: 'Title',
    codigoLabel: 'Code',
    nivelLabel: 'Level',
    organizacionLabel: 'Organization',
    departamentoLabel: 'Department',
    reportsToLabel: 'Reports to',
    assignedPersonLabel: 'Assigned person (optional)',
    selectOption: 'Select',
    noneOption: 'None',
    noAssignment: 'Unassigned',
    creating: 'Creating...',
    createPuesto: 'Create position',
    assignPersonTitle: 'Assign person',
    puestoLabel: 'Position',
    searchByNameOrEmail: 'Search by name or email...',
    noResults: 'No results',
    errorAssignPerson: 'Error assigning person',
    vacantLabel: 'Vacant',
    ocupadoLabel: 'Occupied',
    soloVacantes: 'Vacancies only',
    puestoDetail: {
      loading: 'Loading position...',
      notFound: 'Position not found',
      goBack: 'Go back',
      viewInOrgChart: 'View in org chart',
      fichaTitle: 'Position sheet',
      openDocument: 'Open document',
      noFicha: 'This position has no associated characterization sheet.',
      createFicha: 'Create position sheet',
      creatingFicha: 'Creating...',
    },
    orgs: {
      title: 'Organizations',
      newOrg: '+ New Organization',
      loadingOrgs: 'Loading organizations...',
      noOrgs: 'No organizations registered.',
      editOrg: 'Edit Organization',
      newOrgTitle: 'New Organization',
      name: 'Name',
      shortName: 'Short name',
      type: 'Type',
      departments: 'Departments',
      positions: 'Positions',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      view: 'View',
      nameRequired: 'Name is required',
      confirmDeleteOrg: 'Delete this organization? All departments and positions will be deleted.',
      holding: 'Holding',
      empresa: 'Company',
      filial: 'Subsidiary',
      sucursal: 'Branch',
      division: 'Division',
      unidadNegocio: 'Business Unit',
      ute: 'JV (UTE)',
      jointVenture: 'Joint Venture',
      concesion: 'Concession',
      back: 'Back',
      departmentTab: (n: number) => `Departments (${n})`,
      positionTab: (n: number) => `Positions (${n})`,
      newDept: '+ New Department',
      editDept: 'Edit Department',
      newDeptTitle: 'New Department',
      parentDept: 'Parent department',
      noneRoot: 'None (root level)',
      noDepts: 'No departments',
      confirmDeleteDept: 'Delete this department?',
      newPosition: '+ New Position',
      editPosition: 'Edit Position',
      newPositionTitle: 'New Position',
      superior: 'Superior',
      none: 'None',
      noDept: 'No department',
      noPositions: 'No positions',
      confirmDeletePosition: 'Delete this position?',
      person: 'Person',
      parentOrg: 'Parent organization',
      nifCif: 'Tax ID / CIF',
      country: 'Country',
      parentOrgLabel: 'Parent',
      subsidiaries: 'Subsidiaries',
      vistaArbol: 'Tree',
      vistaTabla: 'Table',
    },
    governance: {
      title: 'Governance Analysis',
      vacanciesTab: 'Vacancies',
      matrixTab: 'Responsibility Matrix',
      impactTab: 'Impact Analysis',
      vacanciesCount: (n: number) => `${n} position(s) without assigned person`,
      noVacancies: 'No vacancies. All positions are filled.',
      matrixDesc: (procs: number, puestos: number) =>
        `${procs} processes × ${puestos} responsible positions`,
      errorLoadMatrix: 'Could not load the responsibility matrix.',
      noDataMatrix: 'Not enough data for the responsibility matrix.',
      processCol: 'Process',
      selectPuesto: 'Select position for analysis',
      selectPuestoPlaceholder: 'Select position...',
      analyzing: 'Analyzing...',
      analyzeImpact: 'Analyze Impact',
      analyzedPuesto: 'Analyzed position',
      directSubordinates: (n: number) => `Direct subordinates (${n})`,
      affectedProcesses: (n: number) => `Affected processes (${n})`,
      affectedDocuments: (n: number) => `Affected documents (${n})`,
      governanceRoles: (n: number) => `Governance roles (${n})`,
      noSubordinates: 'No subordinates',
      noProcesses: 'No linked processes',
      noDocuments: 'No linked documents',
      impactHint:
        "Select a position and click 'Analyze Impact' to see the full analysis of removing that position.",
      titulo: 'Title',
      persona: 'Person',
      noGovernanceRoles: 'No governance roles assigned',
      actions: 'Actions',
      viewInOrgChart: 'View in org chart',
      // Governance Bodies (F2.10+F2.11+F2.12)
      organosTab: 'Governance Bodies',
      organosEmpty: 'No governance bodies registered',
      organosLoading: 'Loading governance bodies...',
      organosErrorLoad: 'Failed to load governance bodies',
      miembrosActivos: (n: number) => `${n} active member${n !== 1 ? 's' : ''}`,
      sinMiembros: 'No members registered',
      estadoActivo: 'Active',
      estadoCesado: 'Former',
      cargoCol: 'Role',
      nombreCol: 'Name',
      desdeCol: 'From',
      hastaCol: 'To',
      estadoCol: 'Status',
    },
    admin: {
      title: 'Administration',
      personas: 'People',
      puestos: 'Positions',
      departamentos: 'Departments',
      roles: 'Governance roles',
      organizaciones: 'Organizations',
      centros: 'Sites',
      niveles: 'Levels',
      catalogos: 'Catalogs',
      usuarios: 'Users ↔ People',
      glosario: 'Glossary',
      organos: 'Governance Bodies',
      newPerson: 'New person',
      editPerson: 'Edit person',
      newPosition: 'New position',
      editPosition: 'Edit position',
      newDepartment: 'New department',
      editDepartment: 'Edit department',
      newRole: 'New role',
      newOrganization: 'New organization',
      newSite: 'New site',
      newLevel: 'New level',
      newCatalog: 'New catalog',
      // 0455 — admin top-level
      activo: 'Active',
      inactivo: 'Inactive',
      // 0458 — i18n sweep phase 2: table column headers
      acciones: 'Actions',
      fichaFR: 'FR Sheet',
      // 0473 — RF / RG homogenization (shared labels for buttons and toggle)
      mostrarInactivos: 'Show inactive',
      fichaCrear: 'Create FR',
      fichaVer: 'View FR',
      rolesContador: 'roles',
      // 0461 — i18n sweep phase 3: residual headers/labels (estado exists below)
      tipo: 'Type',
      nif: 'Tax ID',
      cargo: 'Role',
      desde: 'From',
      hasta: 'To',
      entidad: 'Entity',
      miembros: 'Members',
      // 0457 — generic tooltips reused across admin components
      tooltips: {
        editar: 'Edit',
        desactivar: 'Deactivate',
        cesar: 'Dismiss',
        eliminar: 'Delete',
        fichaAsignada: 'FR assigned',
        sinFichaRol: 'No FR',
        toggleActivar: 'Activate',
        toggleDesactivar: 'Deactivate',
        verFichaRol: 'View FR',
        rolPlataforma: 'Platform role',
        desactivarOrgano: 'Deactivate body',
        cesarMiembro: 'Dismiss member',
        eliminarMiembro: 'Delete member',
        // 0471 M12 — didactic tooltips per Admin tab (shared shell)
        adminPersonas: {
          titulo: 'People directory',
          ayuda:
            'Catalog of the tenant’s individuals: employees, collaborators and externals with traceability of position, department and employment status.\n\nA person can hold several positions. Changes here are reflected in the responsible parties assigned across processes, documents and governance bodies.',
        },
        adminPuestos: {
          titulo: 'Positions catalog',
          ayuda:
            'Register of every position defined in the organization. Each position belongs to a functional role, a department and an organization, and may have several people assigned over time.\n\nPositions are the minimum unit for assigning responsibilities in processes and documents.',
        },
        adminDepartamentos: {
          titulo: 'Departments',
          ayuda:
            'Organizational units that shape the organization. Each department belongs to an organization, may have a parent department (hierarchy) and a responsible position.\n\nThe unit type (configurable per tenant) classifies the department as Division, Area, Unit, Team, etc.',
        },
        adminNivelesPuesto: {
          titulo: 'Position levels',
          ayuda:
            'Catalog of position hierarchy levels (Junior, Senior, Manager, Director, etc.). Each position is assigned to a level, which drives the compensation band, responsibility complexity and career path.\n\nReorder the levels using the arrows to reflect the professional progression inside the organization.',
        },
        adminRolesFuncionales: {
          titulo: 'Functional roles',
          ayuda:
            'Catalog of functional roles in the organization. They describe the duties, competencies and responsibilities a position must fulfill.\n\nEach position inherits from a functional role. The role FR profile acts as the reference template for position profiles (FP).',
        },
        adminRolesGobernanza: {
          titulo: 'Governance roles',
          ayuda:
            'Catalog of governance roles for the tenant (DPO, Compliance Officer, Risk Owner, etc.) with their assigned position and FG profile.\n\nIt separates global roles from per-process roles (managed from the process profile). System roles cannot be deleted.',
        },
        adminTiposUnidad: {
          titulo: 'Organizational unit types',
          ayuda:
            'Configurable catalog of organizational unit types per tenant. Used to classify departments: Division, Area, Unit, Team, etc.\n\nA type cannot be deleted while it has departments attached. They are sorted by the Order field in org charts and selectors.',
        },
        adminCatalogos: {
          titulo: 'Catalogs',
          ayuda:
            'Auxiliary catalogs configurable per tenant (contract types, labor categories, site types, etc.).\n\nEach catalog defines the allowed values for forms and listings. System catalogs cannot be deleted; custom ones can, unless they have records attached.',
        },
        adminCentros: {
          titulo: 'Sites',
          ayuda:
            'Register of physical sites and offices of the tenant (offices, plants, warehouses, branches).\n\nEach site belongs to an organization and stores address, contact and geolocation. Used for position, project and process assignments with territorial scope.',
        },
        adminOrganos: {
          titulo: 'Governance bodies',
          ayuda:
            'Governance bodies of the tenant (Board of Directors, Executive Committee, Audit Committee, etc.) with their members and roles.\n\nEach body belongs to a group entity and keeps a historical record of member appointments and dismissals to satisfy traceability requirements.',
        },
        adminOrganizaciones: {
          titulo: 'Organizations',
          ayuda:
            'Legal entities of the corporate group (companies, joint ventures, branches). They are organized in a corporate tree with cross-holdings.\n\nEach organization stores its tax ID, registered address and relationship with other entities. It is the root of the organizational structure for positions, sites and processes.',
        },
        adminGlosario: {
          titulo: 'Corporate glossary',
          ayuda:
            'Repository of terms and definitions of the governance system. Glossary terms are used in documents, processes and profiles to guarantee a shared language across the organization.\n\nEach term can have synonyms, a category and a do-not-translate flag for proper nouns or technical acronyms.',
        },
        adminUsuariosPersonas: {
          titulo: 'Users ↔ People',
          ayuda:
            'Links each platform user with their person profile in the directory.\n\nThe link is required for the user to appear as responsible in processes, documents and governance bodies. It also lets you assign the platform role (admin, editor, reader) to the user.',
        },
        adminTiposContrato: {
          titulo: 'Contract types',
          ayuda:
            'Catalog of labor contract types configurable per tenant (Permanent, Fixed-term, Internship, Commercial, etc.).\n\nThey are assigned to people in their employment data. A type cannot be deactivated while there are active people using it.',
        },
        adminCategoriasLaborales: {
          titulo: 'Labor categories',
          ayuda:
            'Catalog of labor categories configurable per tenant (Technical, Administrative, Managerial, etc.) according to the applicable collective agreement.\n\nThey are assigned to people in their employment data. A category cannot be deactivated while there are active people using it.',
        },
      },
      // 0471 M12 — shared columns across admin components
      columns: {
        codigo: 'Code',
      },
      // 0457 — per-component placeholders
      organosPlaceholders: {
        nombre: 'Board of Directors of...',
        cargo: 'Sole Director, Director, Secretary...',
      },
      departamentosPlaceholders: {
        codigo: 'E.g.: DEP-001',
      },
      usuariosPlaceholders: {
        busqueda: 'Search by name, code or email...',
      },
      // 0455 — nivel modal keys
      nivelModal: {
        title: 'Position level',
        errorRequired: 'Code and name are required',
      },
      // 0455 — rol funcional panel (2 tabs: Data + Tiptap profile)
      rolFuncionalPanel: {
        nuevoRol: 'New functional role',
        tabDatos: 'Data',
        tabFicha: 'Profile',
        fichaDeshabilitada: 'Save basic data first',
        cancelar: 'Cancel',
        guardar: 'Save',
        saving: 'Saving...',
        fichaNoExiste: 'This role has no FR profile attached.',
        crearFicha: 'Create functional role profile',
        creandoFicha: 'Creating...',
        fichaCreada: 'Profile created',
        fichaGuardada: 'Profile saved',
        errorCargarFicha: 'Error loading the profile',
        fichaMision: 'Role mission',
        fichaFunciones: 'Duties and responsibilities',
        fichaCompetenciasTecnicas: 'Technical competencies',
        fichaCompetenciasTransversales: 'Transversal competencies',
        fichaFormacion: 'Required education',
        fichaExperiencia: 'Required experience',
        fichaCertificaciones: 'Mandatory certifications',
        fichaCondiciones: 'Role conditions',
      },
      noPermission: 'You do not have permission to access this section',
      organizations: 'Organizations',
      sites: 'Sites',
      levels: 'Position levels',
      catalogs: 'Catalogs',
      // AdminPuestos columns and filters (B·I18N.3 — 394)
      colCodigo: 'Code',
      colTitulo: 'Title',
      colDescripcion: 'Description',
      catalogosContador: 'catalogs',
      glosarioContador: 'terms',
      tuoContador: 'unit types',
      departamentosContador: 'departments',
      organizacionesContador: 'organizations',
      organosContador: 'governance bodies',
      colNivel: 'Level',
      colDepartamento: 'Department',
      colOrganizacion: 'Organization',
      colPlantilla: 'Headcount',
      colVacante: 'Vacancy',
      colVacantes: 'Vacancies',
      personasTitle: 'People',
      newPersona: 'New person',
      colNombre: 'Name',
      colEmail: 'Email',
      colTipo: 'Type',
      colEstado: 'Status',
      colPuesto: 'Position',
      countLabel: 'people',
      todosLosNiveles: 'All levels',
      todosLosDepartamentos: 'All departments',
      nuevoPuesto: 'New position',
      vacanteSingular: (n: number) => `${n} vacancy`,
      vacantesPluralN: (n: number) => `${n} vacancies`,
      countPuestos: 'positions',
      sections: {
        identification: 'Identification',
        contact: 'Contact',
        employment: 'Employment data',
        organization: 'Organization',
        notes: 'Notes',
        levels: 'Position levels',
      },
      save: 'Save',
      cancel: 'Cancel',
      saved: 'Saved successfully',
      error: 'Error saving',
      confirmDeactivate: 'Confirm deactivation of this person?',
      search: 'Search...',
      noResults: 'No results',
      required: 'Required field',
      vacante: 'Vacant',
      ocupado: 'Occupied',
      comingSoon: 'Coming soon',
      linkUser: 'Link',
      unlinkUser: 'Unlink',
      notLinked: '(not linked)',
      linked: 'Linked',
      tiposUnidad: 'Unit Types',
      newTipoUnidad: 'New unit type',
      editTipoUnidad: 'Edit unit type',
      nombreCorto: 'Short name',
      orden: 'Order',
      color: 'Color',
      esDefault: 'Default',
      cantDeleteTipoConDeptos: 'Cannot delete: has associated departments',
      confirmDeleteTipo: 'Delete this organizational unit type?',
      rolesFuncionales: 'Functional Roles',
      newRolFuncional: 'New functional role',
      editRolFuncional: 'Edit functional role',
      descripcion: 'Description',
      nivelMinimo: 'Minimum level',
      nivelMaximo: 'Maximum level',
      puestosAsociados: 'Positions',
      confirmDeactivateRol: 'Deactivate this functional role?',
      rolFuncional: 'Functional role',
      direccion: 'Address',
      codigoPostal: 'Postal Code',
      provincia: 'Province',
      pais: 'Country',
      telefono: 'Phone',
      personaContacto: 'Contact person',
      latitud: 'Latitude',
      longitud: 'Longitude',
      urlUbicacion: 'Location link (Google Maps)',
      estado: 'Status',
      editNivel: 'Edit level',
      colorFondo: 'Background color',
      conflictoIndependencia: 'Independence conflict',
      sinConflictos: 'No conflicts',
      puestoAsignado: 'Assigned position',
      personaEnPuesto: 'Person in position',
      sinPuestoAsignado: 'No position assigned',
      rolPlataforma: 'Platform role',
      gestionarAcceso: 'Manage access',
      usuarioVinculado: 'Linked user',
      sinUsuarioVinculado: 'No linked user',
      personaPanel: {
        sinUsuario: 'This person has no linked user.',
        usuario: {
          email: 'Email',
          rol: 'Role',
          estado: 'Status',
        },
      },
      tiposContrato: {
        label: 'Contract Types',
        title: 'Contract Types',
        newItem: 'New contract type',
        editItem: 'Edit contract type',
        columns: {
          codigo: 'Code',
          nombre: 'Name',
          descripcion: 'Description',
          activo: 'Active',
          acciones: 'Actions',
        },
        placeholders: {
          nombre: 'e.g. Permanent',
          descripcion: 'Optional description',
        },
        confirmDeactivate: 'Deactivate this contract type?',
        enUso: 'Cannot deactivate: there are active people with this type',
        itemLabel: 'contract types',
      },
      categoriasLaborales: {
        label: 'Job Categories',
        title: 'Job Categories',
        newItem: 'New job category',
        editItem: 'Edit job category',
        columns: {
          codigo: 'Code',
          nombre: 'Name',
          descripcion: 'Description',
          activo: 'Active',
          acciones: 'Actions',
        },
        placeholders: {
          nombre: 'e.g. Technician',
          descripcion: 'Optional description',
        },
        confirmDeactivate: 'Deactivate this job category?',
        enUso: 'Cannot deactivate: there are active people with this category',
        itemLabel: 'job categories',
      },
      participacionEnPadre: '% Ownership',
      arbolSocietario: 'Corporate tree',
      vistaArbol: 'Tree',
      vistaTabla: 'Table',
      tipoPersonaEmpleado: 'Employee',
      tipoPersonaColaborador: 'Collaborator',
      tipoPersonaExterno: 'External',
      estadoActivo: 'Active',
      estadoBaja: 'Terminated',
      estadoSuspendido: 'Suspended',
      tipoCostoOperaciones: 'Operations',
      tipoCostoEstructuraProyecto: 'Project structure',
      tipoCostoEstructuraCorporativa: 'Corporate structure',
      rolesGobernanza: {
        title: 'Governance roles',
        newRol: 'New role',
        search: 'Search...',
        noResults: 'No results',
        colNombre: 'Custom name',
        colActivo: 'Active',
        colAccion: 'Action',
        saved: 'Saved successfully',
        countLabel: 'roles',
        sistema: 'System',
        verFichaFG: 'View FG sheet',
        verFichaTitle: 'View Governance Role Sheet',
        vacante: 'Vacant',
        activo: 'Active',
        inactivo: 'Inactive',
        rolSistema: 'System role',
        desactivar: 'Deactivate',
        activar: 'Activate',
        rolActivado: 'Role activated',
        rolDesactivado: 'Role deactivated',
        errorCambiarEstado: 'Error changing status',
        colPuestoAsignado: 'Assigned position',
        colPersonaEnPuesto: 'Person in position',
        tipoRol: {
          REPRESENTANTE_PROCESO: 'Process Representative',
          DIRECCION_RESPONSABLE_PROCESO: 'Process Responsible Direction',
          DPO: 'Data Protection Officer',
          OFICIAL_CUMPLIMIENTO: 'Compliance Officer',
          PROPIETARIO_RIESGO: 'Risk Owner',
          AUDITOR_INTERNO: 'Internal Auditor',
          RESPONSABLE_CALIDAD: 'Quality Manager',
          PROPIETARIO_PROCESO: 'Process Owner',
          MIEMBRO_CONSEJO: 'Board Member',
          SECRETARIO_CONSEJO: 'Board Secretary',
          PERSONALIZADO: 'Custom',
        },
        modal: {
          tituloNuevo: 'New governance role',
          tituloEditar: 'Edit governance role',
          tipoRol: 'Role type',
          puestoAsignado: 'Assigned position',
          seleccionar: 'Select...',
          nombrePersonalizado: 'Custom name',
          placeholderNombre: 'Only if type = CUSTOM',
          ambito: 'Scope',
          placeholderAmbito: 'Process range...',
          cancelar: 'Cancel',
          guardando: 'Saving...',
          guardar: 'Save',
          errorGuardar: 'Error saving',
          camposObligatorios: 'Role type and position are required',
        },
        // 0469: flat listing extras
        mostrarInactivos: 'Show inactive',
        toastActivado: 'Role activated',
        toastDesactivado: 'Role deactivated',
        confirmDesactivar: 'Deactivate this governance role?',
        toggleActivoError: 'Could not change the status',
        verAuditoria: 'View audit log',
        colConflicto: 'Conflict',
        acciones: 'Actions',
        editar: 'Edit',
        eliminar: 'Delete',
        sinConflictos: 'No conflicts',
        conflictoIndependencia: 'Independence conflict',
        sinPuestoAsignado: 'No position assigned',
        ambito: 'Scope',
        de: 'of',
        roles: 'roles',
      },
      // 0469: Unified governance role panel — 3 tabs Data | FG Sheet | Audit.
      rolGobernanzaPanel: {
        nuevoRol: 'New governance role',
        tabDatos: 'Data',
        tabFicha: 'FG sheet',
        tabAuditoria: 'Audit',
        fichaDeshabilitada: 'Roles of this type do not have a specific FG sheet',
        auditoriaDeshabilitada: 'Available after saving the role',
        tipoRol: 'Role type',
        puesto: 'Assigned position',
        ambito: 'Scope',
        ambitoHelp: 'Scope of application of the role',
        nombrePersonalizado: 'Custom name',
        nombrePersonalizadoSoloPersonalizado: 'Only available when role type is CUSTOM',
        nombrePersonalizadoPlaceholder: 'e.g. IT risk owner',
        activo: 'Active',
        seleccionar: 'Select...',
        personaEnPuesto: 'Person in position',
        rolSistemaNoEditable: 'System role — role type, position and active are not editable',
        errorTipoObligatorio: 'Role type is required',
        errorPuestoObligatorio: 'Position is required',
        cancelar: 'Cancel',
        guardar: 'Save',
        saving: 'Saving...',
        fichaNoExiste: 'This role has no FG sheet yet.',
        crearFicha: 'Create governance role sheet',
        creandoFicha: 'Creating...',
        fichaCreada: 'Sheet created',
        fichaGuardada: 'Sheet saved',
        fichaMision: 'Role mission',
        fichaFunciones: 'Functions and responsibilities',
        fichaCompetencias: 'Required competencies',
        fichaRelaciones: 'Key relationships',
        fichaIndicadores: 'Performance indicators',
        errorCargarFicha: 'Error loading the sheet',
        errorCargarAuditoria: 'Error loading the audit log',
        auditoriaVacia: 'This role has no audit records yet.',
        auditoriaLimiteNota: 'Showing last 50 entries. Full access from Compliance.',
        auditoriaAccionCrear: 'Created',
        auditoriaAccionActualizar: 'Updated',
        auditoriaAccionEliminar: 'Deleted',
        auditoriaUsuarioDesconocido: 'Unknown user',
        auditoriaDatosAnteriores: 'Previous data',
        auditoriaDatosNuevos: 'New data',
      },
      // 0470: new governance role types catalog (per tenant).
      tiposRolGobernanza: {
        titulo: 'Governance roles',
        buscar: 'Search...',
        mostrarInactivos: 'Show inactive',
        nuevoCustom: 'New custom role',
        nuevoCustomTitulo: 'New custom governance role',
        nombre: 'Name',
        descripcion: 'Description',
        cancelar: 'Cancel',
        crear: 'Create',
        nombreRequerido: 'Name required',
        tipoCreado: 'Role type created',
        tipoEliminado: 'Type deleted',
        sistemaNoDesactivable: 'System types cannot be deactivated',
        confirmEnUso: 'This type has active assignments. Reassign or deactivate them first.',
        confirmEliminar: 'Delete this role type?',
        badgeSistema: 'SYSTEM',
        ambitoGlobal: 'Global',
        ambitoPorProceso: 'Per process',
        colNombre: 'Name',
        colDescripcion: 'Description',
        colAmbito: 'Scope',
        colPuestos: 'Positions',
        colActivo: 'Active',
        colFicha: 'FG sheet',
        colAcciones: 'Actions',
        estadoActivo: 'Active',
        estadoInactivo: 'Inactive',
        fichaVer: 'View FG',
        fichaCrear: 'Create FG',
        editar: 'Edit',
        eliminar: 'Delete',
        sinResultados: 'No results',
        // 0473 — homogenization with RF (footer counter + toggle action)
        contadorRoles: 'roles',
        toggleActivar: 'Activate',
        toggleDesactivar: 'Deactivate',
      },
      // 0470: redesigned panel for governance role Type (4 tabs).
      tipoRolGobernanzaPanel: {
        tabDatos: 'Data',
        tabAsignaciones: 'Assignments',
        tabFicha: 'FG sheet',
        tabAuditoria: 'Audit',
        asignacionesDeshabilitada: 'Save the type first',
        fichaDeshabilitada: 'Save the type first',
        auditoriaDeshabilitada: 'Save the type first',
        nuevoTipo: 'New role type',
        badgeSistema: 'SYSTEM',
        codigo: 'Code',
        nombre: 'Name',
        descripcion: 'Description',
        ambito: 'Scope',
        ambitoGlobal: 'Global',
        ambitoPorProceso: 'Per process (managed from the process sheet)',
        activo: 'Active',
        avisoSistema:
          'This is a system role type: the name cannot be changed and assignments are managed from the process sheet.',
        sistemaSiempreActivo: '(System types cannot be deactivated)',
        guardar: 'Save',
        creacionDesdeCatalogo: 'New types are created from the catalog',
        porProcesoInfo: 'Per-process roles are managed from each process sheet.',
        seleccionarPuesto: 'Select a position',
        asignar: 'Assign position',
        confirmDesasignar: 'Remove this assignment?',
        asignacionesActivas: 'Active assignments',
        sinAsignaciones: 'No active assignments',
        vacante: 'Vacant',
        quitar: 'Remove',
        errorCargar: 'Could not load the detail',
      },
      // 0453: occupation states (1 position = 1 active assignment max)
      estadoVacante: 'Vacant',
      estadoOcupado: 'Filled',
      paginationPrev: 'Previous',
      paginationNext: 'Next',
      paginationPage: 'Page',
      // Unified position panel (0453): 5 tabs Data | Assignments | Org chart | Profile | Governance roles
      puestoPanel: {
        nuevoPuesto: 'New position',
        tabDatos: 'Data',
        tabAsignaciones: 'Assignments',
        tabOrganigrama: 'Org chart',
        tabFicha: 'Profile',
        tabRolesGobernanza: 'Governance roles',
        // 0470 M9: reciprocity with governance roles tab
        rolesGobernanzaInfo:
          'Governance roles assigned to this position. Per-process roles (Representative, Responsible direction) are managed from the process sheet.',
        seleccionarRol: 'Select a role type',
        asignarRol: 'Assign role',
        rolesActivos: 'Active roles',
        sinRolesGobernanza: 'No governance roles assigned',
        badgeSistema: 'SYSTEM',
        gestionadoPorProceso: 'Managed from the process',
        quitar: 'Remove',
        confirmDesasignarRol: 'Remove this role from the position?',
        sistema: 'System',
        labelTitulo: 'Title',
        labelCodigo: 'Code',
        labelNivel: 'Level',
        labelRolFuncional: 'Functional role',
        labelOrganizacion: 'Organization',
        labelDepartamento: 'Department',
        codigoPreview: '(preview)',
        codigoAutogenerado: '(auto-generated)',
        codigoPendiente: '(will be generated on save)',
        requiredTitulo: 'Title is required',
        requiredNivel: 'Level is required',
        requiredOrg: 'Organization is required',
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
        createPuesto: 'Create position',
        asignacionesHeader: 'Position assignments',
        asignarPersona: 'Assign person',
        tooltipOcupado: 'End the previous assignment first',
        sinAsignaciones: 'No assignments',
        colPersona: 'Person',
        colCodigoPersona: 'Code',
        colFechaInicio: 'Start date',
        colEstado: 'Status',
        colAccion: 'Action',
        estadoActivo: 'Active',
        estadoFinalizado: 'Ended',
        finalizar: 'End',
        asignacionFinalizada: 'Assignment ended',
        errorFinalizar: 'Error ending assignment',
        asignacionCreada: 'Person assigned successfully',
        asignarPersonaA: 'Assign person to',
        buscarPersona: 'Search person',
        placeholderBuscar: 'Name or code...',
        fechaInicio: 'Start date',
        fte: 'FTE (0-1)',
        esPrincipal: 'Primary',
        asignar: 'Assign',
        asignando: 'Assigning...',
        seleccionaPersona: 'Select a person',
        reportaA: 'Reports to',
        sinPadre: 'No superior',
        supervisa: 'Supervises',
        sinHijos: 'No direct reports',
        editarOrganigrama: 'Edit in org chart',
        fichaPuesto: 'Position profile',
        fichaNoExiste: 'This position has no profile yet.',
        crearFicha: 'Create profile',
        creandoFicha: 'Creating...',
        guardarFicha: 'Save profile',
        fichaCreada: 'Profile created successfully',
        fichaGuardada: 'Profile saved',
        errorCargarFicha: 'Error loading profile',
        fichaMision: 'Position mission',
        fichaFunciones: 'Duties and responsibilities',
        fichaCompetenciasTecnicas: 'Technical competencies',
        fichaCompetenciasTransversales: 'Transversal competencies',
        fichaFormacion: 'Required academic training',
        fichaExperiencia: 'Required professional experience',
        fichaCertificaciones: 'Mandatory certifications',
        fichaCondiciones: 'Position conditions',
        // 0454 M2 · UX
        asignarPersonaTooltipOcupado:
          'Finish the active assignment before assigning another person.',
        dirtyWarningTitle: 'Unsaved changes',
        dirtyWarningMessage: 'You have unsaved changes in {tabs}. Discard them?',
        dirtyWarningDiscard: 'Discard and close',
        dirtyWarningCancel: 'Back to panel',
        guardarOrganigrama: 'Save organigram',
        cancelarOrganigrama: 'Cancel',
        guardarFichaTab: 'Save profile',
        cancelarFicha: 'Cancel',
        // 0454 M3 · Organigrama editable
        supervisor: 'Supervisor',
        sinPadreSeleccionado: 'No superior assigned',
        placeholderBuscarPadre: 'Search parent position...',
        // 0454 M4 · Tiptap toolbar
        toolbarHeading1: 'Heading 1',
        toolbarHeading2: 'Heading 2',
        toolbarHeading3: 'Heading 3',
        toolbarBold: 'Bold',
        toolbarItalic: 'Italic',
        toolbarUnderline: 'Underline',
        toolbarBulletList: 'Bullet list',
        toolbarOrderedList: 'Numbered list',
        toolbarBlockquote: 'Quote',
        toolbarAlignLeft: 'Align left',
        toolbarAlignCenter: 'Align center',
        toolbarAlignRight: 'Align right',
        toolbarColor: 'Color',
        toolbarColorBlack: 'Black',
        toolbarColorBlue: 'Blue',
        toolbarColorRed: 'Red',
        toolbarColorGreen: 'Green',
        toolbarClearFormat: 'Clear format',
        toolbarUndo: 'Undo',
        toolbarRedo: 'Redo',
      },
    },
    madurez: {
      codigo: 'Code',
      cuestionarioLecturaSolo: 'Diagnosis approved · questionnaire frozen (read-only)',
      fuenteAnalisis: 'Analyze',
      fuente_CUESTIONARIO: 'Questionnaire',
      fuente_REAL: 'Actual',
      fuente_AMBAS: 'Both',
      niveles: 'Levels — hover a cell for the detail',
      resumenEjecutivo: 'Executive summary',
      dafo: 'SWOT matrix',
      lecturaConsultor: "Consultant's reading",
      borradorIa: 'AI draft',
      requiereRevision: 'Needs review',
      conclusionBloqueada: 'Diagnosis approved · read-only',
      pick_QUICK_WIN: 'Quick win',
      pick_RETO: 'Challenge',
      pick_POSIBLE: 'Possible',
      pick_DESCARTAR: 'Discard',
      escenarios: 'What-if scenarios',
      nuevoEscenario: 'Create scenario',
      sinEscenarios: 'No scenarios yet. Create one to simulate a structural change.',
      viable: 'Viable',
      noViable: 'Not viable',
      impulsoras: 'Driving',
      restrictivas: 'Restraining',
      evaluarEscenario: 'Evaluate',
      generarDesde: 'Generate from this',
      lectura: 'Reading',
      vistaReal: 'Actual (org chart)',
      vistaCuestionario: 'Questionnaire',
      nivelGlobalReal: 'Global level · Actual',
      nivelGlobalCuest: 'Global level · Questionnaire',
      coberturaCuest: 'Questionnaire',
      opcional: '(optional)',
      errMotorNoDisponible:
        'The AI engine is unavailable or out of quota. Retry or check the providers.',
      errRespuestaInvalida: 'The AI returned an invalid response. Please retry.',
      errGenerico: 'Something went wrong. Please retry.',
      conclusionConsultor: 'Governance engineer conclusion',
      conclusionPlaceholder: 'Your expert reading of the context, beyond the objective data…',
      hojaRuta: 'Roadmap',
      responsable: 'Owner',
      horizonte: 'Horizon',
      discrepanciaRealCuest: 'Reality ↔ questionnaire discrepancies',
      colDimension: 'Dimension',
      colReal: 'Real',
      colPercepcion: 'Perception',
      colLectura: 'Reading',
      lecturaSinDato: 'No questionnaire data',
      lecturaCoincide: 'Matches',
      lecturaInfravalora: 'Underrated: reality exceeds perception',
      lecturaSobreestima: 'Overrated: perceived more mature than it is',
      guardarConclusion: 'Save conclusion',
      guardado: 'Saved',
      generando: 'Generating analysis…',
      regenerar: 'Regenerate AI analysis',
      generarAnalisis: 'Generate AI analysis',
      via: 'V·IA',
      cargando: 'Loading…',
      sinAnalisis: 'No AI analysis yet. Generate one to get a diagnosis and recommendations.',
      sentinel: 'Sentinel',
      sentinelError: 'critical alerts — the analysis cannot be validated until they are resolved.',
      sentinelWarn: 'warnings to review.',
      diagnostico: 'Diagnosis',
      recomendaciones: 'Recommendations',
      noAnclada: 'AI proposal',
      anclada: 'anchored to catalog',
      fortalezas: 'Strengths',
      riesgos: 'Risks',
      validar: 'Validate analysis',
      bloqueadoSentinel: 'Blocked by Sentinel',
      generandoInforme: 'Generating report…',
      descargarInforme: 'Download Word report',
      descargarPy: 'Download .py exporter',
      generandoPy: 'Generating .py…',
      generarMegaprompt: 'Generate claude.ai megaprompt',
      generandoMegaprompt: 'Generating megaprompt…',
      verInformeHtml: 'Generate HTML report',
      generandoHtml: 'Generating HTML…',
    },
  },

  // People module
  people: {
    title: 'People',
    directory: 'People Directory',
    newPerson: '+ New Person',
    total: 'Total',
    employees: 'Employees',
    collaborators: 'Collaborators',
    externals: 'External',
    active: 'Active',
    inactive: 'Terminated',
    noPosition: 'No position',
    filteredStats: 'Filtered statistics',
    searchPlaceholder: 'Search by name, surname or email...',
    allTypes: 'All types',
    employee: 'Employee',
    collaborator: 'Collaborator',
    external: 'External',
    all: 'All',
    activeFilter: 'Active',
    inactiveFilter: 'Terminated',
    allDepts: 'All departments',
    fullName: 'Full name',
    position: 'Position',
    type: 'Type',
    loadingDirectory: 'Loading directory...',
    noPersonsFound: 'No persons found with the applied filters.',
    previous: 'Previous',
    pageOf: (page: number, total: number) => `Page ${page} of ${total}`,
    next: 'Next',
    newPersonTitle: 'New Person',
    code: 'Code',
    personType: 'Person Type',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    hireDate: 'Hire Date',
    contractType: 'Contract Type',
    directionCode: 'Direction Code',
    requiredFields: 'Code, first name, last name and email are required',
    errorCreatePerson: 'Error creating person',
    creatingPerson: 'Creating...',
    createPerson: 'Create Person',
    assetsPlaceholder: 'Assets assigned to this person are managed from the V·IA Inventory module.',
    goToInventory: 'Go to Inventory',
    form: {
      code: 'Code *',
      personType: 'Person Type *',
      firstName: 'First Name *',
      lastName: 'Last Name *',
      email: 'Email *',
      phone: 'Phone',
      hireDate: 'Hire Date',
      contractType: 'Contract Type',
      directionCode: 'Direction Code',
      nif: 'NIF',
      displayName: 'Display Name',
      secondaryEmail: 'Secondary Email',
      mobilePhone: 'Mobile Phone',
      status: 'Status',
      jobCategory: 'Job Category',
      terminationDate: 'Termination Date',
      birthDate: 'Birth Date',
      supervisor: 'Supervisor',
      country: 'Country',
      gender: 'Gender',
      readOnly: '(read only)',
      codigoAutogenerado: '(auto-generated)',
      paisDerivadoTooltip: 'Derived from primary work center',
      department: 'Department',
      tipoCosto: 'Cost type',
      centroCostes: 'Cost center (Project)',
      workCenter: 'Work center',
      center: 'Work center',
      cambioEstadoTitulo: (de: string, a: string) => `Status change: ${de} → ${a}`,
      cambioEstadoMotivo: 'Reason',
      cambioEstadoFecha: 'Change date',
      cambioEstadoObs: 'Notes',
      cambioEstadoObsPlaceholder: 'Optional',
      cambioEstadoConfirmar: 'Confirm change',
      cambioEstadoMotivoBaja: 'Reason is required for this status change',
    },
    placeholders: {
      code: 'EMP-XXX',
      contractType: 'Permanent',
    },
    validation: {
      required: 'Required field',
      emailFormat: 'Invalid email format',
      codeRequired: 'Code is required',
      nameRequired: 'Name is required',
      lastNameRequired: 'Last name is required',
      emailRequired: 'Email is required',
    },
    pageSize: 'per page',
    showing: (from: number, to: number, total: number) => `${from}-${to} of ${total}`,
    selectAll: 'Select all',
    selected: (n: number) => `${n} selected`,
    bulkTerminate: (n: number) => `Terminate (${n})`,
    bulkExportCsv: (n: number) => `Export CSV (${n})`,
    confirmBulkTerminate: (n: number) =>
      `Terminate ${n} people? This will close all their active assignments.`,
    bulkTerminateSuccess: (n: number) => `${n} people terminated successfully`,
    bulkTerminateError: 'Error terminating people',
    loadingPerson: 'Loading person...',
    personNotFound: 'Person not found',
    terminate: 'Terminate',
    confirmTerminate: 'Terminate this person? All active assignments will be closed.',
    confirmFinalizarAsignacion: 'End this assignment? Data will be preserved in the history.',
    confirmDesasignarProyecto: 'Unassign this person from the project?',
    confirmDesasignarCentro: 'Unassign this person from this center?',
    personalData: 'Personal Data',
    positionAndChart: 'Position and Org Chart',
    projects: 'Projects',
    centers: 'Centers',
    assets: 'Assets',
    governanceTab: 'Governance',
    processesAndDocs: 'Processes & Documents',
    processesRepresented: 'Represented processes',
    noProcesses: 'No processes assigned',
    documentsCreated: 'Documents created',
    documentsApproved: 'Documents approved',
    noDocuments: 'No documents',
    noGovernanceRoles: 'No governance roles assigned',
    rolesByPosition: 'Roles by position',
    directRoles: 'Direct roles',
    savedOk: 'Saved successfully',
    saveChanges: 'Save Changes',
    currentPosition: 'Current Position',
    noPositionAssigned: 'No position assigned',
    orgChartPosition: 'Org Chart Position',
    positionHistory: 'Position History',
    noHistory: 'No history',
    puesto: 'Position',
    department: 'Department',
    from: 'From',
    to: 'To',
    status: 'Status',
    activeStatus: 'Active',
    finishedStatus: 'Finished',
    finalize: 'Finalize',
    confirmFinalize: 'Finalize this assignment?',
    assignedProjects: 'Assigned Projects',
    noProjects: 'No assigned projects',
    project: 'Project',
    role: 'Role',
    dedication: 'Dedication',
    unassign: 'Unassign',
    confirmUnassignProject: 'Unassign from this project?',
    workCenters: 'Work Centers',
    noCenters: 'No assigned centers',
    center: 'Center',
    city: 'City',
    primary: 'Primary',
    yes: 'Yes',
    no: 'No',
    confirmUnassignCenter: 'Unassign from this center?',
    assignedAssets: 'Assigned Assets',
    noAssets: 'No assigned assets (assets are managed from V·IA Inventory)',
    asset: 'Asset',
    governanceRoles: 'Governance Roles',
    noGovernanceRolesLegacy: 'No governance roles assigned (assigned through the position)',
    scope: 'Scope',
    processOwner: 'Process Owner',
    dpo: 'Data Protection Officer',
    complianceOfficer: 'Compliance Officer',
    internalAuditor: 'Internal Auditor',
    boardMember: 'Board Member',
    personaDrawer: {
      title: 'Person Detail',
      contact: 'Contact',
      positionInfo: 'Position & Department',
      organization: 'Organization',
      miniOrgChart: 'Mini org chart',
      supervisor: 'Direct supervisor',
      subordinates: 'Direct reports',
      main: 'Main',
    },
    historialEstado: {
      titulo: 'Status history',
      sinCambios: 'No changes recorded.',
      colFecha: 'Date',
      colDe: 'From',
      colA: 'To',
      colMotivo: 'Reason',
      colObservaciones: 'Notes',
      colPor: 'By',
    },
  },

  // Home page
  home: {
    searchPlaceholder: 'Search documents, processes, people...',
    documents: 'Documents',
    processes: 'Processes',
    pending: 'Pending',
    current: 'Current',
    engineerings: 'Governance Engineerings',
    recentActivity: 'Recent Activity',
    noRecentActivity: 'No recent activity',
    news: 'News',
    pendingDocs: 'Pending',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
    sent: 'Sent',
    approved: 'Approved',
    rejected: 'Rejected',
    published: 'Published',
  },

  // Quick search
  search: {
    searching: 'Searching...',
    noResultsFound: 'No results found',
    recentDocs: 'Recent documents',
    typeToSearch: 'Type to search documents by name or code',
    searchTooltip: 'Search (Ctrl+K)',
  },

  // Breadcrumb
  breadcrumb: {
    home: 'Home',
    detail: 'Detail',
    admin: 'Administration',
    aiAssistant: 'AI Assistant',
    orgChart: 'Organization Chart',
    organizations: 'Organizations',
    governance: 'Governance',
    people: 'People',
    processMap: 'Process Map',
    characterization: 'Characterization',
    smartSearch: 'Smart Search',
    docAudit: 'Document Audit',
    dashboards: 'Dashboards',
    regulations: 'Regulations',
    internalAudits: 'Internal Audits',
    nonConformities: 'Non-Conformities',
    projects: 'Projects',
    purchases: 'Purchases',
    assets: 'Assets',
    requests: 'Requests',
    news: 'News',
    surveys: 'Surveys',
    events: 'Events',
    settings: 'Settings',
    import: 'Import',
    assistant: 'Assistant',
    document: 'Document',
    process: 'Process',
    processSheet: 'Process Sheet',
  },

  // Settings page
  settings: {
    loadingConfig: 'Loading configuration...',
    brandTab: 'Brand Identity',
    generalTab: 'General Settings',
    usersTab: 'Users',
    statsTab: 'Statistics',
    configSaved: 'Configuration saved successfully',
    logoUpdated: 'Logo updated',
    errorUpload: 'Error uploading file',
    brand: 'Brand',
    brandName: 'Brand Name',
    font: 'Font',
    colors: 'Colors',
    primary: 'Primary',
    secondary: 'Secondary',
    accent: 'Accent',
    preview: 'Preview',
    logos: 'Logos',
    mainLogo: 'Main logo',
    headerLogo: 'Header logo',
    favicon: 'Favicon',
    saving: 'Saving...',
    saveChanges: 'Save changes',
    generalConfig: 'General Settings',
    language: 'Language',
    spanish: 'Spanish',
    timezone: 'Timezone',
    customDomain: 'Custom domain',
    plan: 'Plan',
    activeModules: 'Active modules',
    users: 'Users',
    newUser: '+ New user',
    name: 'Name',
    emailCol: 'Email',
    roleCol: 'Role',
    statusCol: 'Status',
    actionsCol: 'Actions',
    activeUser: 'Active',
    inactiveUser: 'Inactive',
    deactivate: 'Deactivate',
    confirmDeactivate: 'This user will be deactivated. Continue?',
    userDeactivated: 'User deactivated',
    newUserTitle: 'New user',
    fullName: 'Full name',
    emailAndNameRequired: 'Email and name are required',
    userCreated: 'User created successfully',
    creatingUser: 'Creating...',
    createUser: 'Create user',
    tenantStats: 'Tenant Statistics',
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    totalDocs: 'Total Documents',
    publishedDocs: 'Published Documents',
    totalProcesses: 'Total Processes',
    loadingStats: 'Loading statistics...',
  },

  // Audit page (compliance)
  audit: {
    title: 'Document Audit',
    allEntities: 'All entities',
    allActions: 'All actions',
    fromDate: 'From',
    toDate: 'To',
    clearFilters: 'Clear filters',
    refresh: 'Refresh',
    date: 'Date',
    user: 'User',
    action: 'Action',
    entity: 'Entity',
    detail: 'Detail',
    loadingRecords: 'Loading records...',
    noRecordsFound: 'No audit records found',
    pageOf: (page: number, total: number, records: number) =>
      `Page ${page} of ${total} · ${records} records`,
    previous: 'Previous',
    next: 'Next',
    errorLoading: 'Error loading audit records',
    actions: {
      createDoc: 'Create Document',
      editDoc: 'Edit Document',
      sendReview: 'Send for Review',
      approveVersion: 'Approve Version',
      rejectVersion: 'Reject Version',
      publishDoc: 'Publish Document',
      deactivate: 'Deactivate',
      createRef: 'Create Reference',
      deleteRef: 'Delete Reference',
      startChat: 'Start Conversation',
      login: 'Login',
      logout: 'Logout',
    },
  },

  // Compliance module
  compliance: {
    tabs: {
      normative: 'Normative',
      internalAudit: 'Internal Audits',
      nonConformities: 'Non-Conformities',
    },
    landing: {
      title: 'Regulatory Compliance',
      description:
        'Regulations, audits, non-conformities and corrective actions. Ensures compliance with corporate standards.',
      normativeDesc: 'Corporate regulatory framework management and regulatory compliance',
      auditDesc: 'Planning and monitoring of internal system audits',
      nonConformitiesDesc: 'Recording and handling of non-conformities and corrective actions',
    },
  },

  // Process module
  process: {
    madurezEmpresa: {
      tab: 'Enterprise maturity',
      errorEvals: 'Could not load assessments',
      errorHeatmap: 'Could not load the heatmap',
      errorCrear: 'Could not create the assessment (edit permission?)',
      errorSembrar: 'Could not seed the capabilities',
      errorConclusion: 'Could not save the conclusion',
      errorAprobar: 'Could not approve (director role?)',
      titulo: 'Enterprise maturity · PEMM (transformation capability)',
      nueva: '+ New assessment',
      global: 'Enterprise level',
      vacio:
        'No transformation-capability assessment yet. Create the first one with "+ New assessment".',
      sinSiembra: 'The assessment has no capabilities. Seed all 13 at E-1 to start the audit.',
      sembrar: 'Seed 13 capabilities',
      heatmap: 'Capability matrix 13 × 4',
      aprobar: 'Approve assessment',
      aprobada: '✓ Approved (read-only)',
      verDetalle: 'Highlight in the questionnaire',
      eslabon: 'Weakest link: it sets the enterprise level',
      conNota: 'Has a note',
      radar: 'Radar by category (weakest link)',
      evolucion: 'Enterprise evolution',
      sinEvolucion: 'With a single assessment there is no evolution to show yet.',
      conclusion: 'Governance engineer conclusion',
      conclusionPh:
        'Summary: can the enterprise sustain the improvement of its processes? Weakest link(s), what unlocks the next level…',
      guardando: 'Saving…',
      guardar: 'Save',
      guardado: '✓ Saved',
      cuestionarioTitulo: 'PEMM-Enterprise questionnaire',
      errorGuardar: 'Could not save (edit permission?)',
      anadirNota: 'Add note',
      lecturaSolo: 'Approved evaluation · questionnaire frozen (read-only)',
      cuestionarioAyuda:
        'Rate each statement from 1 (Not at all) to 4 (Fully). The average of a capability sets its E level; the enterprise is worth its weakest link. The result is reflected in the heatmap and radar instantly.',
      expandirBloques: 'Expand blocks',
      contraerBloques: 'Collapse blocks',
      expandirNotas: 'Expand notes',
      contraerNotas: 'Collapse notes',
      refNiveles: 'Level reference (Hammer)',
      iaErrorCargar: 'Could not load the analysis',
      iaErrorGenerar: 'Could not generate the analysis (edit permission or quota?)',
      iaErrorValidar: 'Could not validate (director role or Sentinel alerts?)',
      iaErrorExport: 'Could not generate the report (edit permission?)',
      iaTitulo: 'V·IA Governance analysis',
      iaGenerando: 'Generating…',
      iaRegenerar: 'Regenerate AI analysis',
      iaGenerar: 'Generate V·IA analysis',
      iaValidado: '✓ Validated',
      iaGenerado: 'Generated',
      expWordTip: 'Corporate Word report (PO.34.MO.02)',
      expWord: 'Download Word report',
      expPyTip: '.py exporter to reproduce the Word in claude.ai (PO.34.HE.02)',
      expPy: 'Download .py exporter',
      expMegaTip: 'Megaprompt .md to generate the premium report in claude.ai',
      expMega: 'Generate megaprompt claude.ai',
      expHtmlTip: 'Standalone HTML report (opens in a new tab)',
      expHtml: 'Generate HTML report',
      iaVacio:
        'No analysis yet. Generate one: V·IA will read the 13 capabilities and diagnose the weakest link, what unlocks the next level, and a SWOT.',
      iaSentinel: '⚠ Sentinel flagged critical alerts: review before validating.',
      iaResumen: 'Executive summary',
      iaLecturaConsultor: "Consultant's reading",
      iaDafo: 'SWOT matrix',
      iaDiagnostico: 'Diagnosis',
      iaRecomendaciones: 'Recommendations',
      iaFortalezas: 'Strengths',
      iaRiesgos: 'Risks',
      iaValidando: 'Validating…',
      iaValidar: 'Validate analysis',
      iaBorrador: 'AI draft',
      tcoError: 'Could not save the study (edit permission?)',
      tcoTitulo: 'Investment study · TCO / ROI',
      tcoTotal: 'Total TCO',
      roiHorizonte: 'Horizon ROI',
      roiPermanente: 'Steady-state ROI',
      payback: 'Payback',
      noRecuperado: 'Not recovered',
      flujoNeto: 'Net cash flow',
      flujoAcum: 'Cumulative cash flow',
      horizonte: 'Horizon (years)',
      costesDirectos: 'Direct costs (€)',
      costesIndirectos: 'Indirect costs (€)',
      curvaAdopcion: 'Adoption curve (0-1)',
      beneficios: 'Annual benefits (steady state)',
      conceptoPh: 'Concept (e.g. reduction of rework)',
      addBeneficio: '+ Add benefit',
      tcoGuardar: 'Save study',
      tcoNota:
        'Horizon ROI = (Σ benefits − TCO) / TCO × 100. Yearly benefit = full benefit × adoption curve.',
    },
    madurezPemm: {
      tab: 'Process maturity',
      titulo: 'Process maturity · PEMM (Hammer)',
      proceso: 'Process',
      elegirProceso: '— Choose a process —',
      evaluacion: 'Assessment',
      nueva: '+ New assessment',
      global: 'Process level',
      vacioProceso: 'Choose a process to assess its PEMM maturity (Hammer’s 13 enablers).',
      vacioEval:
        'This process has no PEMM assessments yet. Create the first one with “+ New assessment”.',
      sinSiembra: 'The assessment has no enablers. Seed all 13 at P-1 to start the audit.',
      sembrar: 'Seed 13 enablers (pre-filled from the map)',
      heatmap: 'Enabler matrix 13 × 4',
      aprobar: 'Approve assessment',
      aprobada: '✓ Approved (read-only)',
      eslabon: 'Weakest link: it sets the process level',
      errorProcesos: 'Could not load processes',
      errorEvals: 'Could not load assessments',
      errorHeatmap: 'Could not load the heatmap',
      errorCrear: 'Could not create the assessment (edit permission?)',
      errorSembrar: 'Could not seed the enablers',
      errorGuardar: 'Could not save the level (edit permission?)',
      errorAprobar: 'Could not approve (director role?)',
      verDetalle: 'View definition and notes',
      conNota: 'Has a note',
      cuestionarioTitulo: 'PEMM questionnaire',
      cuestionarioAyuda:
        'Rate each statement from 1 (Not at all) to 4 (Fully). The average of an enabler sets its P level; the process is worth its weakest link. The result is reflected in the heatmap and radar instantly.',
      addNota: '+ Note',
      notaVer: '📝 Note',
      refNiveles: 'Level reference (Hammer)',
      expandirBloques: 'Expand blocks',
      contraerBloques: 'Collapse blocks',
      expandirNotas: 'Expand notes',
      contraerNotas: 'Collapse notes',
      anadirNota: 'Add note',
      lecturaSolo: 'Approved evaluation · questionnaire frozen (read-only)',
      radar: 'Radar by category (weakest link)',
      evolucion: 'Process evolution',
      sinEvolucion: 'With a single assessment there is no evolution to show yet.',
      conclusion: 'Governance engineer conclusion',
      conclusionPh: 'Diagnosis summary: weakest link(s), what unlocks the next level, priorities…',
      guardando: 'Saving…',
      guardar: 'Save',
      guardado: '✓ Saved',
      metodoTitulo: 'How it is assessed · PEMM (Hammer 2007)',
      metodoTexto:
        'It is an expert audit: for each enabler, pick the P level the process truly meets. The process level = its weakest link (minimum). Raise the weakest enabler to raise the process.',
      detalle: 'Enabler detail',
      detalleVacio:
        'Select an enabler in the matrix to see its definition by level and add your notes.',
      notaIngeniero: 'Engineer notes (evidence)',
      notaPh: 'Evidence backing the assigned level…',
      guardarNota: 'Save note',
      errorNota: 'Could not save the note',
      errorConclusion: 'Could not save the conclusion',
      iaTitulo: 'V·IA Governance analysis',
      iaResumen: 'Executive summary',
      iaBorrador: 'AI draft',
      iaLecturaConsultor: "Consultant's reading",
      zenicTitulo: 'Audit evidence (ZENIC)',
      zenicCualitativa: 'Qualitative response (interview)',
      zenicCuantitativa: 'Quantitative response (data, %)',
      zenicAnalisis: 'Rationale for the level (why this P)',
      zenicLeccion: 'Lesson learned',
      guardarZenic: 'Save evidence',
      roadmapTitulo: 'Roadmap',
      matrizPick: 'PICK prioritization (impact × complexity)',
      kotter: 'Kotter',
      brecha: 'Gap',
      owner: 'Owner',
      crucesTitulo: 'Crossed strategies (SWOT)',
      cruceFo: 'SO · Strengths + Opportunities (offensive)',
      cruceFa: 'ST · Strengths + Threats (defensive)',
      cruceDo: 'WO · Weaknesses + Opportunities (reorientation)',
      cruceDa: 'WT · Weaknesses + Threats (survival)',
      iaGenerar: 'Generate V·IA analysis',
      iaRegenerar: 'Regenerate',
      iaGenerando: 'Generating…',
      iaGenerado: 'Generated',
      iaValidado: '✓ Validated',
      iaVacio:
        'No analysis yet. Generate one: V·IA will read the 13 enablers and diagnose the weakest link, what unlocks the next level, and a SWOT.',
      iaDiagnostico: 'Diagnosis',
      iaRecomendaciones: 'Recommendations (prioritized)',
      iaFortalezas: 'Strengths',
      iaRiesgos: 'Risks',
      iaDafo: 'SWOT matrix',
      iaDafoF: 'Strengths',
      iaDafoD: 'Weaknesses',
      iaDafoO: 'Opportunities',
      iaDafoA: 'Threats',
      iaValidar: 'Validate analysis',
      iaValidando: 'Validating…',
      iaValidadoNota: '✓ Analysis validated (ready for report)',
      iaSentinel: '⚠ Sentinel flagged critical alerts: review before validating.',
      iaErrorCargar: 'Could not load the analysis',
      iaErrorGenerar: 'Could not generate the analysis (edit permission or quota?)',
      iaErrorValidar: 'Could not validate (director role or Sentinel alerts?)',
      expMega: 'Generate megaprompt claude.ai',
      expMegaTip: 'Megaprompt .md to generate the premium report in claude.ai',
      expHtml: 'Generate HTML report',
      expHtmlTip: 'Standalone HTML report (opens in a new tab)',
      iaErrorExport: 'Could not generate the report (edit permission?)',
      expWord: 'Download Word report',
      expWordTip: 'Corporate Word report (PO.34.MO.02)',
      expPy: 'Download .py exporter',
      expPyTip: '.py exporter to reproduce the Word in claude.ai (PO.34.HE.02)',
      tcoTitulo: 'Investment study · TCO / ROI',
      tcoTotal: 'Total TCO',
      roiHorizonte: 'Horizon ROI',
      roiPermanente: 'Steady-state ROI',
      payback: 'Payback',
      noRecuperado: 'Not recovered',
      flujoNeto: 'Net cash flow',
      flujoAcum: 'Cumulative cash flow',
      horizonte: 'Horizon (years)',
      costesDirectos: 'Direct costs (€)',
      costesIndirectos: 'Indirect costs (€)',
      curvaAdopcion: 'Adoption curve (0-1)',
      beneficios: 'Annual benefits (steady state)',
      conceptoPh: 'Concept (e.g. reduction of rework)',
      addBeneficio: '+ Add benefit',
      tcoGuardar: 'Save study',
      tcoError: 'Could not save the study (edit permission?)',
      tcoNota:
        'Horizon ROI = (Σ benefits − TCO) / TCO × 100. Yearly benefit = full benefit × adoption curve.',
    },
    madurez: {
      title: 'Process maturity · BPMM',
      loading: 'Loading process maturity…',
      nuevaEvaluacion: 'New assessment',
      aprobar: 'Approve',
      cuestionario: 'Questionnaire',
      ocultarCuestionario: 'Hide questionnaire',
      cuestionarioTitle: 'BPMM questionnaire',
      cuestionarioLoading: 'Loading BPMM questionnaire…',
      nivelGlobalReal: 'Overall level · Actual (map)',
      nivelGlobalCuest: 'Overall level · Questionnaire',
      coberturaModelo: 'Model coverage',
      coberturaCuest: 'Questionnaire:',
      estado: 'Status',
      codigo: 'Code:',
      emptyTitle: 'No process maturity assessments yet',
      emptyDesc:
        'Create an assessment: the engine will read the process map and seed the 7 BPMM pillars.',
      lectura: 'View:',
      vistaReal: 'Actual (process map)',
      vistaCuestionario: 'Questionnaire',
      heatmapTitle: 'Heatmap 7 pillars × 5 levels',
      radarTitle: 'Radar 7 pillars',
      cuestIntro:
        'Answer based on your perception (1 = Never, 5 = Always). The result is contrasted with the actual reading of the process map.',
      liderazgo: 'Leadership',
      anadirNota: 'Add note',
      guardando: 'Saving…',
      guardarRespuestas: 'Save answers',
      respuestasGuardadas: 'Answers saved',
      lecturaSolo: 'Assessment approved · questionnaire frozen (read-only)',
      tab: 'Maturity',
      analisisIA: 'V·IA Governance Analysis',
      ocultarAnalisis: 'Hide AI analysis',
      discrepancias: 'Questionnaire discrepancies',
      discrepanciasEmpty: 'No answers recorded yet.',
      discrepante: 'Discrepancy (variance ≥ threshold)',
      colPregunta: 'Question',
      colRespondentes: 'Resp.',
      colVarianza: 'Variance',
      timeline: 'Overall level evolution',
      timelineEmpty: 'Not enough history yet.',
      niveles: 'BPMM levels (Robledo) — hover over a cell for details',
      notasPilar: 'Governance notes',
      expandirBloques: 'Expand blocks',
      contraerBloques: 'Collapse blocks',
      expandirNotas: 'Expand notes',
      contraerNotas: 'Collapse notes',
      conclusionConsultor: 'Governance engineer conclusion',
      opcional: '(optional)',
      guardarConclusion: 'Save conclusion',
      conclusionBloqueada: 'Diagnosis approved · read-only',
      conclusionPlaceholder: 'Your expert reading of the context, beyond the objective data…',
      guardado: 'Saved',
      cuestionarioHint:
        'Select an assessment to respond and triangulate the objective data with perception.',
      analisis: {
        fuente: 'Source:',
        ambas: 'Both',
        real: 'Actual',
        cuestionario: 'Questionnaire',
        generando: 'Generating analysis…',
        regenerar: 'Regenerate AI analysis',
        generar: 'Generate AI analysis',
        generarAnalisis: 'Generate AI analysis',
        validar: 'Validate analysis',
        cargando: 'Loading…',
        vacio:
          'No analysis yet. Generate one: the AI diagnoses process maturity and proposes prioritised improvement actions (the AI proposes, the consultant validates).',
        sinAnalisis:
          'No AI analysis yet. Generate one: the AI diagnoses process maturity and proposes prioritised improvement actions (the AI proposes, the consultant validates).',
        basadoNotas: "The analysis incorporates the consultant's governance notes.",
        recomendaciones: 'Recommendations',
        fortalezas: 'Strengths',
        riesgos: 'Risks',
        dafoFortalezas: 'STRENGTHS',
        dafoDebilidades: 'WEAKNESSES',
        dafoOportunidades: 'OPPORTUNITIES',
        dafoAmenazas: 'THREATS',
        analisisIA: 'V·IA Governance Analysis',
        descargarInforme: 'Download Word report',
        descargarPy: 'Download .py exporter',
        generarMegaprompt: 'Generate claude.ai megaprompt',
        verInformeHtml: 'Generate HTML report',
        resumenEjecutivo: 'Executive summary',
        validado: 'Validated',
        borradorIa: 'AI draft',
        lecturaConsultor: "Consultant's reading",
        dafo: 'SWOT matrix',
        diagnostico: 'Diagnosis',
        anclada: 'anchored to the catalogue',
        hojaRuta: 'Roadmap',
        responsable: 'Owner',
        horizonte: 'Horizon',
        discrepancias: 'Questionnaire discrepancies',
        discrepanciasEmpty: 'No answers recorded yet.',
        colPregunta: 'Question',
        colRespondentes: 'Resp.',
        colVarianza: 'Variance',
        discrepante: 'Discrepancy (variance ≥ threshold)',
        fuenteAnalisis: 'Analyze',
        fuente_CUESTIONARIO: 'Questionnaire',
        fuente_REAL: 'Actual',
        fuente_AMBAS: 'Both',
        fuenteHelp_CUESTIONARIO: 'Team perception / engineer judgement',
        fuenteHelp_REAL: 'Objective reading of the process map',
        fuenteHelp_AMBAS: 'Compares actual vs perception and highlights the gap',
        via: 'V·IA',
      },
    },
    mapaTitle: 'Process map',
    explorerTitle: 'Document explorer',
    tooltips: {
      mapa: {
        titulo: 'Process map',
        ayuda:
          'Global view of all processes in the management system.\n\n· Strategic (PE) — define direction and corporate governance.\n· Operational (PO) — generate direct business value.\n· Support (PS) — service the operational processes.\n\nClick a group to see its processes, and a process to see its flowchart and associated documentation.',
      },
      explorador: {
        titulo: 'Document explorer',
        ayuda:
          'Complete catalogue of management system documents.\n\n· Only documents in Vigente (Active) status are mandatory.\n· Use filters to search by type, process or status.\n· Click a document to view its full content and cross-references.',
      },
      ficha: {
        titulo: 'Process sheet',
        ayuda:
          'Main process document capturing its purpose, scope, owner, inputs, outputs and indicators.\n\n· The process owner ensures its execution and continuous improvement.\n· Inputs and outputs define the process boundaries with other system processes.',
      },
    },
    procesos: 'Processes',
    expandir: 'Expand',
    colapsar: 'Collapse',
    cargando: 'Loading...',
    seleccionarProceso: 'Select a process',
    fichaAqui: 'The process sheet will be displayed here',
    seleccionarDocumento: 'Select a document',
    deLaSeccion: 'from the Documentation section',
    ficha: 'Sheet',
    docs: 'Docs',
    flow: 'Flow',
    visor: 'Viewer',
    flujograma: 'Flowchart',
    fichaCaracterizacion: 'Characterization',
    cargandoFicha: 'Loading process sheet...',
    procesoNoEncontrado: 'Process not found',
    vigente: 'PUBLISHED',
    exportarPdf: 'Export PDF',
    editarProximamente: 'Edit (coming soon)',
    responsable: 'Responsible',
    asistente: 'AI Assistant',
    fichaSubtitle: 'Process Sheet',
    aiDisponible: 'The AI assistant will be available soon',
    escribirMensaje: 'Type a message...',
    identificacion: '1. Identification',
    codigo: 'Code',
    nombreProceso: 'Process Name',
    tipologia: 'Typology',
    grupoFuncional: 'Functional Group',
    fase: 'Phase',
    involucrados: 'Involved',
    sinRolesGobernanza: 'No governance roles assigned',
    descripcionSeccion: '2. Description',
    sinDescripcion: 'No description registered',
    alcance: 'Scope',
    alcanceNoDefinido: 'Scope not defined in the current data model',
    entradasSalidas: '3. Inputs and Outputs',
    entradas: 'Inputs',
    salidas: 'Outputs',
    sinEntradas: 'No data — inputs not modeled in the current version',
    sinSalidas: 'No data — outputs not modeled in the current version',
    reportesRequisitos: '4. Reports and Requirements',
    reportes: 'Reports',
    requisitos: 'Requirements',
    sinReportes: 'No associated reports',
    requisitosNoModelados: 'Regulatory requirements not modeled in the current version',
    documentacion: '5. Documentation',
    sinDocumentos: 'No associated documents',
    herramientasSeccion: '6. Tools',
    sinHerramientas: 'No associated tools',
    indicadoresSeccion: '7. Indicators',
    sinIndicadores: 'No process indicators defined',
    objetivo: 'Objective',
    calculo: 'Calculation',
    documentos: 'Documents',
    cargandoDocumentos: 'Loading documents...',
    seleccioneProcesoFicha: 'Select a process to view its sheet',
    ingenieria: 'Engineering',
    origen: 'Origin',
    destino: 'Destination',
    anadir: 'Add',
    pendiente: 'Pending',
    crearDocumento: 'Create document',
    creando: 'Creating...',
    nombreDocumento: 'Document name',
    tipoDocumental: 'Document type',
    anadirALista: 'Add to list',
    anadirDocumento: 'Add document',
    anadirIndicador: 'Add indicator',
    nuevoIndicador: 'New indicator',
    frecuencia: 'Frequency',
    valorActual: 'Current value',
    sinDescripcionCorto: 'No description',
    descripcionPlaceholder: 'Process description...',
    alcancePlaceholder: 'Process scope...',
    direccionResponsable: 'Responsible Direction',
    representanteProceso: 'Process Representative',
    nuevoInvolucrado: 'New involved:',
    textoEntrada: 'Entry text:',
    nuevoReporte: 'New report:',
    nuevoRequisito: 'New requirement:',
    nuevaHerramienta: 'New tool:',
    eliminarBorrador: 'Delete draft',
    exportPdfPendiente: 'PDF export — feature pending.',
  },

  documentViewer: {
    cargandoDocumento: 'Loading document...',
    documentoNoEncontrado: 'Document not found',
    proceso: 'Process',
    directorResponsable: 'Responsible director',
    representante: 'Representative',
    primeraAprobacion: 'First approval',
    versionVigente: 'Current version',
    motivoRechazo: 'Reason for rejection (optional)',
    indicarMotivo: 'Indicate the reason for rejection...',
    confirmarRechazo: 'Confirm rejection',
    procesando: 'Processing...',
    ocultarIndice: 'Hide index',
    mostrarIndice: 'Show index',
    indice: 'INDEX',
    exportando: 'Exporting...',
    aprobado: 'Document approved successfully',
    rechazado: 'Document rejected — returned to review',
    publicado: 'Document published as current',
    enviadoAprobacion: 'Document sent to approval',
    devueltoBorrador: 'Document returned to draft',
    transicionEjecutada: 'Transition executed successfully',
  },

  docExplorer: {
    documentos: 'Documents',
    todos: 'All',
    estrategicos: 'PE — Strategic',
    operativos: 'PO — Operational',
    soporte: 'PS — Support',
    buscar: 'Search...',
    buscarPlaceholder: 'Search documents...',
    cargandoDocumentos: 'Loading documents...',
    noEncontrados: 'No documents found',
    codigo: 'Code',
    nombre: 'Title',
    proceso: 'Process',
    procesoCol: 'Process',
    representante: 'Representative',
    direccion: 'Direction',
    tipo: 'Type',
    estado: 'Status',
    edicion: 'Ed.',
    fecha: 'Date',
    totalDocumentos: 'Total documents',
    vigentes: 'Published',
    borrador: 'Draft',
    enRevision: 'Under review',
    aprobado: 'Approved',
    todosEstados: 'All statuses',
    todosProcesos: 'All processes',
    mostrando: 'Showing',
    de: 'of',
  },

  workspace: {
    exploradorDocumentos: 'Document Explorer',
    mapaProcesos: 'Process Map',
    cargandoProcesos: 'Loading processes...',
    sinGrupo: 'No group',
    pendientes: 'Pending',
    enRevision: 'In review',
    enAprobacion: 'In approval',
    fichaCaracterizacion: 'Process Sheet',
    documentos: 'Documents',
    selectFromSheet: 'Select a document from the sheet',
    ficha: 'Sheet',
    docs: 'Docs',
    flow: 'Flow',
    visor: 'Viewer',
    tooltips: {
      showFullSheet: 'Show full sheet',
      showOnlyDocs: 'Show only documents',
      hideSheet: 'Hide sheet',
      expandDocument: 'Expand document',
      openFullViewer: 'Open in full viewer',
    },
  },

  changelog: {
    nuevaEdicion: 'New Edition',
    describaCambios: 'Describe the changes that motivate this new edition',
    descripcionCambios: 'Change description',
    obligatorio: 'The change description is required to create a new edition.',
    crearEdicion: 'Create Edition',
    creando: 'Creating...',
  },

  metadata: {
    informacionDocumento: 'Document Information',
    codigo: 'Code',
    nombre: 'Name',
    tipoDocumental: 'Document Type',
    proceso: 'Process',
    estado: 'Status',
    edicionActual: 'Current Edition',
    empresa: 'Company',
    direccion: 'Direction',
    fechaCreacion: 'Creation Date',
    ultimaActualizacion: 'Last Update',
    seleccionarProceso: '— Select process —',
    errorAlGuardar: 'Error saving',
    cicloVida: 'Lifecycle',
  },

  toc: {
    buscarSeccion: 'Search section...',
    portada: 'Cover',
  },

  diff: {
    comparacionVersiones: 'Version comparison',
    cerrar: '✕ Close',
    anadidasLabel: 'added',
    eliminadasLabel: 'removed',
    sinCambios: 'unchanged',
    sinContenido: 'No content to compare',
    lineaAnadida: 'Line added',
    lineaEliminada: 'Line removed',
  },

  viewerHeader: {
    guardando: 'Saving...',
    autoguardadoActivo: 'Autosave active',
    guardar: 'Save',
    guardarYCerrar: 'Save and close',
    descartarCambios: 'Discard changes',
    editar: 'Edit',
    nuevaEdicion: 'New edition',
    creando: 'Creating...',
    exportarDocx: 'Export DOCX',
    exportando: 'Exporting...',
    documentoExportado: 'Document exported successfully',
    errorAlExportar: 'Error exporting',
    confirmarDescartar: 'Discard changes',
    perderanCambios: 'All changes since last save will be lost. This action cannot be undone.',
    descartar: 'Discard',
  },

  flow: {
    cargandoFlujograma: 'Loading flowchart...',
    reintentar: 'Retry',
    guardarBorrador: 'Save draft',
    enviarARevision: 'Send to review',
    historialVersiones: 'Version history',
    deshacer: 'Undo (Ctrl+Z)',
    rehacer: 'Redo (Ctrl+Y)',
    acercar: 'Zoom in',
    alejar: 'Zoom out',
    ajustarPantalla: 'Fit to screen',
    colapsarSubprocesos: 'Collapse subprocesses',
    mostrarCuadricula: 'Show/hide grid',
    mostrarMinimapa: 'Show/hide minimap',
    exportarPng: 'Export PNG',
    exportarPdf: 'Export PDF',
    guardando: 'Saving...',
    viaAsistente: 'VIA — Flowchart Assistant',
    viaDescription: 'The AI assistant for flowchart design will be available soon.',
    entendido: 'Got it',
    excedeTamano: (max: number) =>
      `The flowchart exceeds the normative size (${max} nodes max.). Consider grouping activities into subprocesses.`,
    cerrarAviso: 'Close warning',
    sinFlujogramaPublicado: 'This process has no published flowchart',
    crearDesdeEditor: 'Create one from the flowchart editor',
    vistaLectura: 'Flowchart — Read-only view',
    abrirEnEditor: 'Open in Editor',
    guardarAntes: 'Save the flowchart before sending it for review.',
    enviarRevisionConfirm: 'Send flowchart for review? It cannot be edited until returned.',
    publish: 'Publish',
    publishSuccess: 'Flowchart published successfully',
    nuevaEdicionCreada: 'New edition created',
    errorNuevaEdicion: 'Error creating new edition',
    errorEliminar: 'Error deleting draft',
    errorArchivar: 'Error archiving',
    nuevaSolicitud: 'New request',
    solicitudesVinculadas: 'Linked requests',
    // Toolbar — alignment & distribution
    alinearIzquierda: 'Align left',
    alinearCentroH: 'Align center horizontal',
    alinearDerecha: 'Align right',
    alinearArriba: 'Align top',
    alinearCentroV: 'Align center vertical',
    alinearAbajo: 'Align bottom',
    distribuirH: 'Distribute horizontal',
    distribuirV: 'Distribute vertical',
    igualarTamano: 'Match size',
    autoLayout: 'Auto-layout',
    autoLayoutTitle: 'Auto-layout (ELK)',
    calculando: 'Calculating...',
    exportar: 'Export',
    cuadricula: 'Grid',
    minimapa: 'Minimap',
    toggleRedimensionar: 'Toggle resize',
    versiones: 'Versions',
    auditTrail: 'Audit trail',
    audit: 'Audit',
    // Header actions
    guardar: 'Save',
    guardarYCerrar: 'Save and close',
    descartar: 'Discard',
    editar: 'Edit',
    nuevaEdicionLabel: 'New edition',
    eliminar: 'Delete',
    archivar: 'Archive',
    pantallaCompleta: 'Fullscreen',
    salirPantallaCompleta: 'Exit fullscreen',
    publicarConFirma: 'Publish with electronic signature',
    // Properties panel
    conector: 'Connector',
    etiqueta: 'Label',
    etiquetaConector: 'Connector label',
    estiloLinea: 'Line style',
    solida: 'Solid',
    discontinua: 'Dashed',
    punteada: 'Dotted',
    tipoFlecha: 'Arrow type',
    flecha: 'Arrow',
    sinFlecha: 'No arrow',
    bidireccional: 'Bidirectional',
    abierta: 'Open',
    colorLabel: 'Color',
    propiedades: 'Properties',
    sinNombre: 'Unnamed',
    responsable: 'Responsible',
    sinAsignar: 'Unassigned',
    descripcionLabel: 'Description',
    faseLabel: 'Phase',
    nombre: 'Name',
    cargandoPuestos: 'Loading positions...',
    responsableId: 'Responsible (ID)',
    idPuesto: 'Position ID',
    documentosVinculados: 'Linked documents',
    documentoReferencia: 'Reference document',
    condicion: 'Condition',
    tamano: 'Size',
    procesoReferencia: 'Reference process',
    cargandoProcesos: 'Loading processes...',
    procesoIdLabel: 'Process ID',
    idProceso: 'Process ID',
    nodoTipoInfo: (tipo: string) => `${tipo} node — only supports label.`,
    subprocesoInfo: 'Subprocess content is edited by expanding it on the canvas.',
    sinResultadosPara: (term: string) => `No results for "${term}"`,
    sinDocumentosDisponibles: 'No documents available for this process.',
    cargandoDocumentos: 'Loading documents...',
    buscarDocumento: 'Search document...',
    eliminarDoc: 'Remove',
    // Node type labels
    tipoActividad: 'Activity',
    tipoDecision: 'Decision',
    tipoDocumento: 'Document',
    tipoSubproceso: 'Subprocess',
    tipoInicio: 'Start',
    tipoFin: 'End',
    tipoProcesoRef: 'Process (reference)',
    tipoProcesoGobierno: 'Governance body',
    tipoResultado: 'Result',
    tipoProcesoRefCorto: 'Process Ref.',
    tipoProcesoGobiernoCorto: 'Gov. body',
    // Phases fallback
    faseDiagnostico: 'Diagnosis',
    faseArquitectura: 'Architecture',
    faseDespliegue: 'Deployment',
    faseOperacion: 'Operation',
    faseMadurez: 'Maturity',
    // Shape library
    formas: 'Shapes',
    fases: 'Phases',
    agregarFase: '+ Add phase',
    nombrePlaceholder: 'Name...',
    arrastrarForma: 'Drag a shape onto the canvas to add it.',
    clicRenombrar: 'Click to rename',
    renombrarFase: 'Rename phase',
    eliminarFase: 'Delete phase',
    expandirIzquierda: 'Expand left',
    expandirDerecha: 'Expand right',
    gobCorporativo: 'Corp. Governance',
    procesoRef: 'Process (ref)',
    // Node detail panel
    cerrar: 'Close',
    herramientas: 'Tools',
    etiquetasLabel: 'Labels',
    documentoReferenciado: 'Referenced document',
    subprocesoLabel: 'Subprocess',
    nodosInternos: (n: number) => `${n} internal nodes`,
    procesoVinculado: 'Linked process',
    si: 'Yes',
    no: 'No',
  },

  processMap: {
    title: 'Process Map',
    kpi: {
      procesosDocumentados: 'Documented Processes',
      flujogramasPublicados: 'Published Flowcharts',
      documentosVigentes: 'Current Documents',
      auditoriasPendientes: 'Pending Audits',
      conformidad: 'Compliance',
      esteTrimestre: (n: number) => `+${n} this quarter`,
      delTotal: (pct: number) => `${pct}% of total`,
      sinCambios: 'No changes',
      vsMesAnterior: (n: number) => `-${n} vs previous month`,
      vsUltimoCiclo: (pct: number) => `+${pct}% vs last cycle`,
      procesosEnRevision: 'Processes Under Review',
      pendientesAprobacion: 'Pending approval',
      indicadoresCumplidos: 'Indicators Met',
      vsObjetivoAnual: '+5% vs annual target',
    },
    cargandoMapa: 'Loading process map...',
    errorAlCargar: 'Error loading',
    sinProcesosRegistrados: 'No registered processes found',
    noticias: 'News',
    verTodo: 'View all',
    noticiasRecientes: (n: number) => `${n} recent news`,
    verTodas: 'View all',
    procesosEstrategicos: 'PE — Strategic Processes',
    ingenieriasGobernanza: 'PO — Governance Engineering',
    procesosSoporte: 'PS — Support Processes',
    cargandoGrupo: 'Loading process group...',
    grupoNoEncontrado: 'Group not found',
    volverAlMapa: '← Back to process map',
    sinProcesosGrupo: 'No processes registered in this group',
    gestionDocumental: 'Document Management',
    documentoVinculado: (n: number) => `${n} linked document${n !== 1 ? 's' : ''}`,
    procedimientos: 'Procedures',
    fichasCaracterizacion: 'Process Sheets',
    flujogramas: 'Flowcharts',
    instruccionesTecnicas: 'Technical Instructions',
    procesosDelGrupo: 'Group processes',
    explorador: 'Document Explorer',
    cargandoProceso: 'Loading process...',
    procesoNoEncontrado: 'Process not found',
    mapa: 'Map',
    secciones: 'Sections',
    descripcion: 'Description',
    responsables: 'Responsible',
    involucrados: 'Involved',
    documentacion: 'Documentation',
    requisitosLabel: 'Requirements',
    reportesLabel: 'Reports',
    herramientasLabel: 'Tools',
    indicadoresLabel: 'Indicators',
    formacion: 'Training',
    sinDescripcion: 'No description registered.',
    tipologiaLabel: 'Typology',
    grupo: 'Group',
    responsableLabel: 'Responsible',
    sinResponsable: 'No responsible assigned',
    sinDocumentacion: 'No associated documentation',
    seccionesDelProceso: 'Process sections',
    vigenteBadge: 'In Force',
    desdePill: 'Since',
    actPill: 'Upd.',
    volverAlFlujograma: 'Back to flowchart',
    sinInvolucrados: 'No involved registered',
    sinDocumentosVinculados: 'No linked documents',
    sinRequisitos: 'No requirements defined',
    sinReportes2: 'No reports defined',
    sinHerramientasDefinidas: 'No tools defined',
    sinIndicadoresDefinidos: 'No indicators defined',
    seccionEnDesarrollo: 'Section under development.',
    formacionEnDesarrollo:
      'The Training section is under development. Training plans associated with the process are configured in the Resources module.',
    objetoYAlcance: 'Object and scope',
    direccionYRepresentante: 'Direction and representative',
    rolesYParticipantes: 'Roles and participants',
    normasAplicables: 'Applicable standards',
    trimestralCMI: 'Quarterly BSC',
    onboardingAnual: 'Annual onboarding',
    kpisDefinidos: (n: number) => `${n} KPIs defined`,
    estrategico: 'Strategic',
    operativo: 'Operational',
    soporteCorto: 'Support',
    mapaDeProcesos: 'Process Map',
    gestionDocumentalTitulo: 'Document Management',
    gestionDocDepartamental: 'Departmental Document Management',
    gestionDocDepartamentalDesc: 'Document lifecycle management by department and functional area.',
    gestionDocProyectos: 'Project Document Management',
    gestionDocProyectosDesc: 'Document management linked to specific projects and deliverables.',
    equipoDelGrupo: 'Group Team',
    directorResponsableLabel: 'Responsible Director',
    dirGralLabel: 'CEO — General Direction',
    representanteDelProceso: 'Process Representative',
    pendienteDeAsignar: 'Pending assignment',
    actividadReciente: 'Recent Activity',
    kpiProcesosDelGrupo: 'Group Processes',
    kpiDocumentosVinculados: 'Linked Documents',
    kpiConFaseAsignada: 'With Assigned Phase',
    kpiConResponsable: 'With Responsible',
    kpiFasesCubiertas: 'Phases Covered',
    kpiDocsPorProceso: 'Docs per Process',
    kpiConformidad: 'Compliance',
    sinProcesos: 'No processes',
    sinFasesAsignadas: 'No phases assigned',
    mayoriaEn: (fase: string) => `Majority in ${fase}`,
    delGrupo: 'of the group',
    deProcesos: (n: number) => `of ${n} processes`,
    delCicloDeVida: 'of lifecycle',
    promedioDelGrupo: 'group average',
    pendienteDeMedicion: 'pending measurement',
    disponible: 'Available',
    pendienteDeConfigurar: 'Pending configuration',
    servicioInformation: 'VALOR·IA Information Service',
    actividad: {
      fichaActualizada: 'Characterization sheet updated',
      flujogramaEnviado: 'Flowchart sent for approval',
      nuevoDocVinculado: 'New document linked to process',
      indicadorRevisado: 'Performance indicator reviewed',
      procesoAsignado: 'Process assigned to new representative',
      hace2Dias: '2 days ago',
      hace3Dias: '3 days ago',
      hace5Dias: '5 days ago',
      hace1Semana: '1 week ago',
      hace2Semanas: '2 weeks ago',
    },
    vistaLectura: 'Flowchart — Read-only view',
    abrirEnEditor: 'Open in Editor',
    exportarPdf: 'Export PDF',
    highlightCards: {
      procesosActivos: 'Active Processes',
      procesosActivosDesc: 'Total processes in operation',
      documentosVigentes: 'Current Documents',
      documentosVigentesDesc: 'Documents in published status',
      pendientesRevision: 'Pending Review',
      pendientesRevisionDesc: 'Documents in review queue',
      indicadoresAlDia: 'KPIs Up to Date',
      indicadoresAlDiaDesc: 'KPIs with updated measurement',
    },
    newsPlaceholder: {
      gobernanza: 'Governance',
      procesos: 'Processes',
      cumplimiento: 'Compliance',
      tecnologia: 'Technology',
      noticia1Titulo: 'New Corporate Governance Framework approved by the Board',
      noticia1Extracto:
        'The Board of Directors has approved the new governance framework that will take effect next quarter.',
      noticia2Titulo: 'Diagnostics phase completed in Process Engineering',
      noticia2Extracto:
        '47 key operational processes have been identified and their interrelations documented.',
      noticia3Titulo: 'Internal ISO 9001 audit: positive results',
      noticia3Extracto: 'The internal audit confirmed 94% compliance with standard requirements.',
      noticia4Titulo: 'Migration to V·IANet 2.0 completed successfully',
      noticia4Extracto: 'All platform modules have been updated to the new architecture.',
    },
  },

  importPage: {
    titulo: 'Import Documents',
    paso1: 'Step 1: Configure source',
    paso1Desc:
      'Specify the path to the directory containing the DOCX files to import. The system will recursively scan all subdirectories.',
    rutaDirectorio: 'Directory path',
    escanear: 'Scan',
    escaneando: 'Scanning...',
    formatoEsperado: 'Expected file format:',
    paso2: 'Step 2: Preview',
    cambiarRuta: 'Change path',
    listo: 'Ready',
    yaExiste: 'Already exists',
    noImportable: 'Not importable',
    creado: 'Created',
    actualizado: 'Updated',
    omitido: 'Skipped',
    configurarOrigen: 'Configure source',
    vistaPrevia: 'Preview',
    importandoLabel: 'Importing',
    resultadosLabel: 'Results',
    importandoDocumentos: 'Importing documents...',
    procesandoArchivos: (n: number) => `Processing ${n} DOCX files. This may take a moment.`,
    errorImportacion: 'Error during import:',
    paso4: 'Step 4: Import results',
    procesoFinalizado: 'Import process finished',
    nuevaImportacion: 'New import',
    irExplorador: 'Go to explorer',
    totalArchivos: 'Total files',
    listosImportar: 'Ready to import',
    yaExistentes: 'Already existing',
    noImportables: 'Not importable',
    totalProcesados: 'Total processed',
    creados: 'Created',
    omitidos: 'Skipped',
    errores: 'Errors',
    errorEscanear: 'Error scanning directory',
    errorImportar: 'Error importing documents',
    archivo: 'File',
    codigoCol: 'Code',
    tipoCol: 'Type',
    procesoCol: 'Process',
    tituloCol: 'Title',
    estadoCol: 'Status',
    nombreCol: 'Name',
    detalleCol: 'Detail',
  },

  information: {
    tabs: {
      search: 'Smart Search',
      audit: 'Document Audit',
      dashboards: 'Dashboards',
    },
  },
  reputation: {
    tabs: {
      news: 'News',
      surveys: 'Surveys',
      events: 'Events',
    },
  },
  tech: {
    title: 'Digital Development',
    description:
      'V·IANet platform, APIs, integration and automation. Manages the technological tools of the ecosystem.',
    descriptions: {
      apps: 'Integrated management applications on the platform',
      projects: 'Project management and initiative tracking',
      procurement: 'Procurement and supply management',
      assets: 'Inventory and technology asset management',
      requests: 'Internal requests and petition management',
      ocr: 'Scan physical documents and PDFs for digitization',
    },
    tabs: {
      apps: 'Apps',
      projects: 'Projects',
      procurement: 'Procurement',
      assets: 'Assets',
      requests: 'Requests',
      ocr: 'OCR / Digitization',
    },
    ocr: {
      title: 'OCR / Digitization',
      dropzone: 'Drag a file or click to select',
      proceso: 'Process',
      tipo: 'Document type',
      processing: 'Processing OCR...',
      submit: 'Digitize',
    },
  },

  // Sign — Action Center
  sign: {
    title: 'Sign Configuration (M15)',
    estado: 'Sign Status',
    activo: 'M15 Sign is active. Activation is managed from Admin > Platform > Modules.',
    inactivo: 'M15 Sign is inactive. Activate it from Admin > Platform > Modules.',
    nivelDefault: 'Default signature level',
    horasRecordatorio: 'Reminder hours',
    horasEscalacion: 'Escalation hours',
    caInterna: 'Internal CA enabled',
    firmaInvitacion: 'Invitation signature',
    politicaEntidad: 'Minimum signature level by entity type',
    certificados: 'Certificates',
    sinCertificados: 'No certificates configured',
    qtspTitle: 'QTSP Provider (Qualified Signature)',
    proximoQTSP: 'QTSP integration available in future versions',
    actionCenter: {
      title: 'Action Center',
      tabs: {
        pendientes: 'Pending',
        historial: 'History',
        delegaciones: 'Delegations',
      },
      pendientesCount: 'pending',
      ordenar: 'Sort',
      porFecha: 'Date',
      porTipo: 'Type',
      cargando: 'Loading...',
      cargandoMas: 'Loading...',
      cargarMas: 'Load more',
      irARevisar: 'Go to review',
      verEntidad: 'View entity',
      delegar: 'Delegate',
      delegadoIdLabel: 'Delegate ID (UUID)',
      motivoLabel: 'Reason',
      confirmarDelegacion: 'Confirm',
      delegacionesRecibidas: 'Received delegations',
      delegacionesRealizadas: 'Made delegations',
      delegadaPor: 'Delegated by',
      delegadaA: 'Delegated to',
      activa: 'Active',
      finalizada: 'Completed',
      // 0662: legacy (signature) vs workflow distinction + revoke.
      tipoLegacyBadge: 'Signature',
      tipoWorkflowBadge: 'Workflow',
      revocar: 'Revoke',
      confirmarRevocar: 'Revoke this delegation? The delegate will no longer see the pending item.',
      timelineTitle: 'Workflow timeline',
      timelineSolicitante: 'Requester',
      timelinePublicador: 'Publisher',
      timelineDone: 'Done',
      timelinePending: 'Pending',
      timelineFuture: 'Upcoming',
      timelineNotFound: 'No workflow information',
      timelineRevisor: 'Reviewer',
      timelineAprobador: 'Approver',
      timelineNotificar: 'Notification',
      timelineNotifyDelivered: 'Delivered',
      timelineNotifyPending: 'Sending',
      detail: {
        tipoEntidad: 'Entity type',
        idArtefacto: 'Artifact ID',
        estado: 'Status',
        estadoPendiente: 'Pending approval',
        nivelFirma: 'Signature level',
        solicitante: 'Requester',
        fechaLimite: 'Deadline',
        hash: 'Hash',
        decision: 'Decision',
        recibido: 'Received',
        accionAyuda:
          'Click "Approve" to confirm the transition or "Reject" providing a reason. "Go to review" opens the artifact to inspect it before deciding.',
        accionAyudaTitulo: 'Action',
      },
      tabEnCurso: 'In progress',
      enCursoEmpty: 'You have no requests in progress',
      enCursoTooltipSolicitante: 'You launched this request',
      enCursoTooltipParticipante: 'You participated in an earlier stage',
      enCursoTooltipFuturo: 'You will act in a future stage',
      // 0666b: Action Center Premium UX
      premium: {
        title: 'Action Center',
        searchPlaceholder: 'Search by subject, scope, code or title…',
        emptyTitle: 'Inbox empty',
        emptySubtitle: 'You have no pending requests right now.',
        loading: 'Loading requests…',
        errorTitle: 'Could not load',
        errorRetry: 'Retry',
        countItems: '{n} requests',
        tabAll: 'All',
        tipoOrganigrama: 'Org chart',
        tipoDoc: 'Documents',
        tipoFlujograma: 'Flowcharts',
        tipoDocLegacy: 'Legacy doc',
        tipoPeticion: 'Requests',
        tipoCompra: 'Purchases',
        actionOpen: 'Open artifact',
        actionOpenOrganigrama: 'Open org chart',
        actionOpenDocumento: 'Open document',
        actionOpenFlujograma: 'Open flowchart',
        detailLoadError: 'Could not load details. Close the modal and try again.',
        colTipo: 'Type',
        colAsunto: 'Subject',
        colCodigo: 'Code',
        colSolicitante: 'Requester',
        colFecha: 'Date',
        colEstado: 'Status',
        detailDetails: 'Details',
        detailFlow: 'Approval flow',
        detailNotified: 'Notified and attachments',
        detailAsunto: 'Subject',
        detailAlcance: 'Scope',
        detailSolicitante: 'Requester',
        detailFechaSolicitud: 'Request date',
        detailEstado: 'Status',
        detailNotifiedTitle: 'Notified',
        detailAttachmentsTitle: 'Attachments',
        detailAttachmentsEmpty: 'No attachments',
        detailNotifiedEmpty: 'No notifications recorded',
        observationsLabel: 'Observations',
        observationsPlaceholder: 'Add an optional comment…',
        rejectMotivoLabel: 'Rejection reason',
        rejectMotivoPlaceholder: 'Explain why you reject the request…',
        actionCancel: 'Cancel',
        actionReject: 'Reject',
        actionApprove: 'Approve',
        actionApproving: 'Approving…',
        actionRejecting: 'Rejecting…',
        approveError: 'Could not approve',
        rejectError: 'Could not reject',
        actionDelegate: 'Delegate',
        // 0669 — views + pagination + enriched premium modal
        vistaLabel: 'View',
        vistaPendientes: 'Pending',
        vistaEnCurso: 'In progress',
        vistaHistorico: 'History',
        paginacionAnterior: 'Previous',
        paginacionSiguiente: 'Next',
        paginacionPagina: 'Page {n} of {total}',
        paginacionPageSize: 'Per page',
        paginacionTotal: '{n} results',
        flowFecha: 'Date',
        flowRol: 'Role',
        flowPuesto: 'Position',
        flowMotivo: 'Comment',
        flowMotivoEmpty: 'No comments',
        flowMotivoTitle: 'View comment',
        notifiedRol: 'Role',
        notifiedPuesto: 'Position',
        notifiedToggleShow: 'Show notified ({n})',
        notifiedToggleHide: 'Hide notified',
        delegar: {
          title: 'Delegate approval',
          searchPlaceholder: 'Search person by name, email or code…',
          searchHint: 'Type to search tenant people.',
          loading: 'Loading people…',
          noResults: 'No matches found',
          motivoLabel: 'Delegation reason',
          motivoPlaceholder: 'Explain why you delegate (≥ 5 chars)…',
          cancel: 'Cancel',
          confirm: 'Delegate',
          delegating: 'Delegating…',
          removeSelection: 'Remove selection',
          errorNoPersona: 'Select a person from the list.',
          errorPersonaSinUsuario:
            'This person has no associated user and cannot receive delegations.',
          errorMotivoCorto: 'Reason must be at least 5 characters.',
          errorDelegar: 'Could not delegate',
        },
        adjuntos: {
          title: 'Attachments',
          dropzonePrompt: 'Drag files here or click to upload',
          dropzoneHint: 'PDF, Office, images, ZIP — max 50 MB per file',
          subiendo: 'Uploading…',
          listaVacia: 'No attachments yet for this artefact',
          descargar: 'Download',
          eliminar: 'Delete attachment',
          confirmarEliminar: 'Delete this attachment? It can be restored from trash.',
          subidoPor: 'Uploaded by',
          tamano: 'Size',
          fecha: 'Date',
          errorMimeType: 'File type not allowed',
          errorTamanoExcedido: 'File exceeds 50 MB',
          errorSubida: 'Could not upload file',
          errorDescarga: 'Could not generate download link',
          errorEliminacion: 'Could not delete attachment',
        },
        comentarios: {
          title: 'Comments',
          placeholder: 'Write a comment about this artefact…',
          enviar: 'Send',
          enviando: 'Sending…',
          cargando: 'Loading comments…',
          listaVacia: 'No comments yet. Be the first to add context.',
          eliminar: 'Delete comment',
          confirmarEliminar: 'Delete this comment? It will be marked as deleted.',
          errorCrear: 'Could not send comment',
          errorEliminar: 'Could not delete comment',
          tiempoAhora: 'just now',
          tiempoMinutos: '{n}m ago',
          tiempoHoras: '{n}h ago',
          tiempoDias: '{n}d ago',
          empty: 'No comments available',
        },
      },
    },
  },

  disciplines: {
    tooltips: {
      structure:
        'VALOR·IA Structure manages the organizational architecture: people, positions, departments, entities and governance relationships.\n\nIt is the database of who is who and how the company is organized to execute its corporate governance model.',
      process:
        'VALOR·IA Process manages the full lifecycle of processes: characterization, flowcharts, indicators and regulatory documentation.\n\nEnsures that all processes are documented, assigned and measured according to the governance model.',
      information:
        'VALOR·IA Information manages the management system document corpus: standards, instructions, records and reports.\n\nEnsures information is up to date, controlled and accessible for everyone involved in the processes.',
      compliance:
        'VALOR·IA Compliance manages regulatory compliance and approval workflows: audits, workflows and corporate sign-off.\n\nGuarantees full traceability of every decision and change with corporate governance impact.',
      tech: 'VALOR·IA Tech manages technological assets, digital projects and tools of the corporate information system.\n\nConnects the technology architecture with the processes and people that use it.',
      reputation:
        'VALOR·IA Reputation manages internal corporate communication: news, events, surveys and the governance narrative.\n\nHelps every member of the organization to know and live the corporate governance model.',
    },
  },
  landing: {
    processes: 'Processes',
    documents: 'Documents',
    tabs: {
      summary: 'Summary',
      processes: 'Processes',
      documents: 'Documents',
      kpis: 'KPIs',
    },
    description: 'Description',
    lifecycle: 'Lifecycle',
    modules: 'Modules',
    lifecyclePhases: {
      diagnosis: 'Diagnosis',
      architecture: 'Architecture',
      deployment: 'Deployment',
      operation: 'Operation',
      maturity: 'Maturity',
    },
    processesRegistered: (n: number, _mod?: string) =>
      `${n} processes registered in this engineering.`,
    selectProcess: 'Select a process from the sidebar to view its characterization sheet.',
    documentsAssociated: (n: number, _mod?: string) => `${n} normative documents associated.`,
    useExplorer: 'Use the Document Explorer to browse and manage documents.',
    kpisInDev: 'Indicators panel under development.',
  },

  // Attached files
  archivos: {
    titulo: 'Attached Files',
    subir: 'Upload file',
    enlace: 'Register link',
    sinArchivos: 'No attached files',
    eliminar: 'Delete file',
    confirmarEliminar: 'Delete this file?',
    subiendo: 'Uploading...',
    subido: 'File uploaded',
    errorSubir: 'Upload error',
    enlaceRegistrado: 'Link registered',
    archivo: 'File',
    enlaceExterno: 'External link',
    storage: 'Storage',
    urlEnlace: 'Link URL',
    nombreArchivo: 'File name',
    tipoMime: 'MIME type',
    descripcion: 'Description',
    tabArchivos: 'Files',
    filtroTipoContenido: 'Content type',
    todosContenidos: 'All content types',
    digital: 'Digital',
    seleccionarArchivo: 'Select file',
    descargar: 'Download',
    abrirEnlace: 'Open link',
    reemplazar: 'Replace file',
  },

  // Migration dashboard
  migracion: {
    titulo: 'Migration Status',
    progreso: 'Migration progress',
    completados: 'Completed',
    pendientes: 'Pending',
    errores: 'With errors',
    de: 'of',
    documentosMigrados: 'documents migrated',
    cargando: 'Loading migration status...',
    errorCargar: 'Error loading migration status',
    PENDIENTE: 'Pending',
    COMPLETADO: 'Completed',
    ERROR: 'Error',
    oleada: 'Wave',
    documento: 'Document',
    estado: 'Status',
  },
  adminProcesos: {
    titulo: 'Process Administration',
    pestana: 'Administration',
    nuevoGrupo: '+ New group',
    nuevoProceso: '+ New process',
    confirmarDesactivar: 'Deactivate process?',
    confirmarDesactivarDesc: 'will be marked as inactive.',
    avisoDocumentos: 'associated documents. Documents will not be deleted.',
    desactivar: 'Deactivate',
    cancelar: 'Cancel',
    inactivo: 'Inactive',
    renombrar: 'Rename group',
    eliminarGrupo: 'Delete group',
    grupoConProcesos: 'Cannot delete a group with processes',
    grupoRenombrado: 'Group renamed',
    procesoCreado: 'Process created',
    procesoActualizado: 'Process updated',
    procesoDesactivado: 'Process deactivated',
    cargando: 'Loading processes...',
    grupos: 'functional groups',
    procesos: 'processes',
    nombreProceso: 'Process name...',
    nombreGrupo: 'Group name...',
  },
  requests: {
    adminTitle: 'Request management',
    tooltips: {
      admin: {
        titulo: 'Request management',
        ayuda:
          'Administration panel for all system requests.\n\nRequests are structured workflows for managing petitions between people and departments with full traceability and controlled approval.',
      },
    },
    admin: {
      title: 'Request Configuration',
      formularios: 'Forms',
      cadenas: 'Chains',
    },
    nuevo: 'New',
    editar: 'Edit',
    eliminar: 'Delete',
    confirmarEliminar: 'Delete this item? This action cannot be undone.',
    guardado: 'Saved successfully',
    nombre: 'Name',
    descripcion: 'Description',
    codigo: 'Code',
    orden: 'Order',
    activo: 'Active',
    grupo: 'Group',
    tipo: 'Request type',
    proceso: 'Linked process',
    requiereFirma: 'Requires signature',
    nivelFirma: 'Signature level',
    fuenteResolucion: 'Resolution source',
    persona: 'Person',
    importeMinimo: 'Minimum amount',
    obligatorio: 'Required',
    rolAprobacion: 'Approval role',
    delegante: 'Delegator',
    delegado: 'Delegate',
    fechaInicio: 'Start date',
    fechaFin: 'End date',
    motivo: 'Reason',
    horasLimite: 'Hour limit',
    escaladoA: 'Escalate to',
    nivelEscalado: 'Escalation level',
    evento: 'Event',
    asunto: 'Subject',
    cuerpoHtml: 'HTML body',
    sinDatos: 'No data configured',
    cargando: 'Loading...',
    seleccionar: 'Select...',
    todos: 'All',
    cancelar: 'Cancel',
    // User-facing (requests)
    nueva: 'New request',
    misSolicitudes: 'My requests',
    pendientesAprobar: 'Pending approval',
    seleccionarTipo: 'Select a request type',
    cambiarTipo: 'Change type',
    guardarBorrador: 'Save draft',
    enviarAprobacion: 'Submit for approval',
    aprobar: 'Approve',
    rechazar: 'Reject',
    devolver: 'Return',
    confirmar: 'Confirm',
    observaciones: 'Observations (optional)',
    timeline: 'Approval history',
    formulario: 'Form',
    auditLog: 'Audit log',
    campoRequerido: 'This field is required',
    campoNoSoportado: 'Field not supported in this version',
    sinTipos: 'No request types configured',
    sinSolicitudes: 'You have no requests',
    sinPendientes: 'No requests pending your approval',
    enviadaOk: 'Request submitted successfully',
    borradorGuardado: 'Draft saved',
    errorGenerico: 'Error processing request',
    configuracion: 'Configuration',
    desdeActividad: 'From flowchart activity',
    // Tabs headings / common shared with admin tabs
    aprobadores: 'Approvers',
    nuevoAprobador: 'New approver',
    seleccionaTipoMsg: 'Select a request type to see its approvers',
    sinAprobadores: 'No approvers configured for this type',
    confirmarEliminarMsg:
      'Are you sure you want to delete this item? This action cannot be undone.',
    delegaciones: 'Delegations',
    nuevaDelegacion: 'New delegation',
    editarDelegacion: 'Edit delegation',
    sinDelegaciones: 'No delegations configured',
    escalados: 'Escalations',
    nuevoEscalado: 'New escalation',
    editarEscalado: 'Edit escalation',
    sinEscalados: 'No escalations configured',
    grupos: 'Groups',
    tipos: 'Types',
    todosGrupos: 'All groups',
    plantillas: 'Templates',
    nuevaPlantilla: 'New template',
    editarPlantilla: 'Edit template',
    sinPlantillas: 'No templates configured',
    asuntoPlaceholder: 'Notification subject',
    tipoSolicitud: 'Request type',
    acciones: 'Actions',
    opcional: 'optional',
    firmada: 'Signed',
  },

  // Glossary
  glosario: {
    title: 'Glossary',
    subtitle: 'Official terminology of the governance system',
    searchPlaceholder: 'Search term, definition or synonym...',
    loading: 'Loading glossary...',
    empty: 'No terms found with those filters',
    errorLoading: 'Error loading glossary',
    all: 'All',
    term: 'term',
    terms: 'terms',
    ofTotal: (total: number) => `of ${total} total`,
    synonyms: 'Synonyms:',
    noTranslate: 'Do not translate',
    categoria: {
      INGENIERIA: 'Engineering',
      TIPO_DOCUMENTAL: 'Document type',
      GENERAL: 'General',
      FASE: 'Phase',
      ROL: 'Role',
      TECNICO: 'Technical',
    },
    admin: {
      title: 'Glossary',
      newTerm: 'New term',
      editTerm: 'Edit term',
      fieldTermino: 'Term',
      fieldDefinicion: 'Definition',
      fieldCategoria: 'Category',
      fieldSinonimos: 'Synonyms',
      fieldNoTraducir: 'Do not translate',
      fieldIdioma: 'Language',
      save: 'Save',
      cancel: 'Cancel',
      confirmDelete: 'Delete this term from the glossary?',
      created: 'Term created',
      updated: 'Term updated',
      deleted: 'Term deleted',
      errorSave: 'Error saving',
      errorDelete: 'Error deleting',
      required: 'Required field',
      synonymsHint: 'Press Enter or comma to add',
      truncated: (n: number) => `${n} synonyms`,
    },
  },
};
